// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, type Options as Options2, type RequestResult, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AccessControlServiceAssignRoleData, AccessControlServiceAssignRoleErrors, AccessControlServiceAssignRoleResponses, AccessControlServiceCheckPermissionData, AccessControlServiceCheckPermissionErrors, AccessControlServiceCheckPermissionResponses, AccessControlServiceCreateApplicationPermissionData, AccessControlServiceCreateApplicationPermissionErrors, AccessControlServiceCreateApplicationPermissionResponses, AccessControlServiceCreateRoleData, AccessControlServiceCreateRoleErrors, AccessControlServiceCreateRoleResponses, AccessControlServiceDeleteApplicationPermissionData, AccessControlServiceDeleteApplicationPermissionErrors, AccessControlServiceDeleteApplicationPermissionResponses, AccessControlServiceDeleteRoleData, AccessControlServiceDeleteRoleErrors, AccessControlServiceDeleteRoleResponses, AccessControlServiceGetApplicationPermissionData, AccessControlServiceGetApplicationPermissionErrors, AccessControlServiceGetApplicationPermissionResponses, AccessControlServiceGetRoleData, AccessControlServiceGetRoleErrors, AccessControlServiceGetRoleResponses, AccessControlServiceListApplicationPermissionsData, AccessControlServiceListApplicationPermissionsErrors, AccessControlServiceListApplicationPermissionsResponses, AccessControlServiceListPermissionsData, AccessControlServiceListPermissionsErrors, AccessControlServiceListPermissionsResponses, AccessControlServiceListRoleMembersData, AccessControlServiceListRoleMembersErrors, AccessControlServiceListRoleMembersResponses, AccessControlServiceListRolesData, AccessControlServiceListRolesErrors, AccessControlServiceListRolesResponses, AccessControlServiceRevokeRoleData, AccessControlServiceRevokeRoleErrors, AccessControlServiceRevokeRoleResponses, AccessControlServiceUpdateApplicationPermissionData, AccessControlServiceUpdateApplicationPermissionErrors, AccessControlServiceUpdateApplicationPermissionResponses, AccessControlServiceUpdateRoleData, AccessControlServiceUpdateRoleErrors, AccessControlServiceUpdateRoleResponses, AdminServiceBootstrapAdminData, AdminServiceBootstrapAdminErrors, AdminServiceBootstrapAdminResponses, ApplicationAuthorizationServiceCheckAccessData, ApplicationAuthorizationServiceCheckAccessErrors, ApplicationAuthorizationServiceCheckAccessResponses, AuditLogServiceExportAuditLogsData, AuditLogServiceExportAuditLogsErrors, AuditLogServiceExportAuditLogsResponses, AuditLogServiceExportPlatformAuditLogsData, AuditLogServiceExportPlatformAuditLogsErrors, AuditLogServiceExportPlatformAuditLogsResponses, AuditLogServiceQueryAuditLogsData, AuditLogServiceQueryAuditLogsErrors, AuditLogServiceQueryAuditLogsResponses, AuditLogServiceQueryPlatformAuditLogsData, AuditLogServiceQueryPlatformAuditLogsErrors, AuditLogServiceQueryPlatformAuditLogsResponses, AuditLogServiceSummarizeAuditStatsData, AuditLogServiceSummarizeAuditStatsErrors, AuditLogServiceSummarizeAuditStatsResponses, AuditLogServiceSummarizePlatformAuditStatsData, AuditLogServiceSummarizePlatformAuditStatsErrors, AuditLogServiceSummarizePlatformAuditStatsResponses, DelegatedAuthorizationServiceGetDelegatedAuthorizationData, DelegatedAuthorizationServiceGetDelegatedAuthorizationErrors, DelegatedAuthorizationServiceGetDelegatedAuthorizationResponses, DelegatedAuthorizationServiceListDelegatedAuthorizationsData, DelegatedAuthorizationServiceListDelegatedAuthorizationsErrors, DelegatedAuthorizationServiceListDelegatedAuthorizationsResponses, DelegatedAuthorizationServiceRevokeDelegatedAuthorizationData, DelegatedAuthorizationServiceRevokeDelegatedAuthorizationErrors, DelegatedAuthorizationServiceRevokeDelegatedAuthorizationResponses, IdentityServiceActivateIdentityData, IdentityServiceActivateIdentityErrors, IdentityServiceActivateIdentityResponses, IdentityServiceCreateIdentityData, IdentityServiceCreateIdentityErrors, IdentityServiceCreateIdentityResponses, IdentityServiceDisableIdentityData, IdentityServiceDisableIdentityErrors, IdentityServiceDisableIdentityResponses, IdentityServiceGetIdentityData, IdentityServiceGetIdentityErrors, IdentityServiceGetIdentityResponses, IdentityServiceListCredentialsData, IdentityServiceListCredentialsErrors, IdentityServiceListCredentialsResponses, IdentityServiceListIdentitiesData, IdentityServiceListIdentitiesErrors, IdentityServiceListIdentitiesResponses, LoginFlowServiceInitLoginFlowData, LoginFlowServiceInitLoginFlowErrors, LoginFlowServiceInitLoginFlowResponses, LoginFlowServiceSubmitLoginData, LoginFlowServiceSubmitLoginErrors, LoginFlowServiceSubmitLoginResponses, OidcProtocolAuthorizeDeviceData, OidcProtocolAuthorizeDeviceErrors, OidcProtocolAuthorizeDeviceResponses, OidcProtocolAuthorizeGetData, OidcProtocolAuthorizeGetErrors, OidcProtocolAuthorizeGetResponses, OidcProtocolAuthorizePostData, OidcProtocolAuthorizePostErrors, OidcProtocolAuthorizePostResponses, OidcProtocolConsentGetData, OidcProtocolConsentGetErrors, OidcProtocolConsentGetResponses, OidcProtocolConsentPostData, OidcProtocolConsentPostErrors, OidcProtocolDeviceVerificationGetData, OidcProtocolDeviceVerificationGetErrors, OidcProtocolDeviceVerificationGetResponses, OidcProtocolDeviceVerificationPostData, OidcProtocolDeviceVerificationPostErrors, OidcProtocolDeviceVerificationPostResponses, OidcProtocolEndSessionGetData, OidcProtocolEndSessionGetErrors, OidcProtocolEndSessionGetResponses, OidcProtocolEndSessionPostData, OidcProtocolEndSessionPostErrors, OidcProtocolEndSessionPostResponses, OidcProtocolExchangeTokenData, OidcProtocolExchangeTokenErrors, OidcProtocolExchangeTokenResponses, OidcProtocolGetDiscoveryData, OidcProtocolGetDiscoveryErrors, OidcProtocolGetDiscoveryResponses, OidcProtocolGetJwksData, OidcProtocolGetJwksErrors, OidcProtocolGetJwksResponses, OidcProtocolIntrospectData, OidcProtocolIntrospectErrors, OidcProtocolIntrospectResponses, OidcProtocolRevokeData, OidcProtocolRevokeErrors, OidcProtocolRevokeResponses, OidcProtocolUserInfoGetData, OidcProtocolUserInfoGetErrors, OidcProtocolUserInfoGetResponses, OidcProtocolUserInfoPostData, OidcProtocolUserInfoPostErrors, OidcProtocolUserInfoPostResponses, OidcProviderServiceResolveClientInfoData, OidcProviderServiceResolveClientInfoErrors, OidcProviderServiceResolveClientInfoResponses, RateLimitServiceCreateBlacklistEntryData, RateLimitServiceCreateBlacklistEntryErrors, RateLimitServiceCreateBlacklistEntryResponses, RateLimitServiceCreateWhitelistEntryData, RateLimitServiceCreateWhitelistEntryErrors, RateLimitServiceCreateWhitelistEntryResponses, RateLimitServiceDeleteBlacklistEntryData, RateLimitServiceDeleteBlacklistEntryErrors, RateLimitServiceDeleteBlacklistEntryResponses, RateLimitServiceDeleteWhitelistEntryData, RateLimitServiceDeleteWhitelistEntryErrors, RateLimitServiceDeleteWhitelistEntryResponses, RateLimitServiceGetBlacklistEntryData, RateLimitServiceGetBlacklistEntryErrors, RateLimitServiceGetBlacklistEntryResponses, RateLimitServiceGetWhitelistEntryData, RateLimitServiceGetWhitelistEntryErrors, RateLimitServiceGetWhitelistEntryResponses, RateLimitServiceListBlacklistEntriesData, RateLimitServiceListBlacklistEntriesErrors, RateLimitServiceListBlacklistEntriesResponses, RateLimitServiceListWhitelistEntriesData, RateLimitServiceListWhitelistEntriesErrors, RateLimitServiceListWhitelistEntriesResponses, RealmServiceActivateRealmData, RealmServiceActivateRealmErrors, RealmServiceActivateRealmResponses, RealmServiceArchiveRealmData, RealmServiceArchiveRealmErrors, RealmServiceArchiveRealmResponses, RealmServiceCreateRealmData, RealmServiceCreateRealmErrors, RealmServiceCreateRealmResponses, RealmServiceDeleteRealmData, RealmServiceDeleteRealmErrors, RealmServiceDeleteRealmResponses, RealmServiceGetRealmData, RealmServiceGetRealmErrors, RealmServiceGetRealmResponses, RealmServiceListRealmsData, RealmServiceListRealmsErrors, RealmServiceListRealmsResponses, RealmServiceSuspendRealmData, RealmServiceSuspendRealmErrors, RealmServiceSuspendRealmResponses, RealmServiceUpdateRealmData, RealmServiceUpdateRealmErrors, RealmServiceUpdateRealmResponses, RecoveryFlowServiceInitRecoveryFlowData, RecoveryFlowServiceInitRecoveryFlowErrors, RecoveryFlowServiceInitRecoveryFlowResponses, RecoveryFlowServiceResetPasswordData, RecoveryFlowServiceResetPasswordErrors, RecoveryFlowServiceResetPasswordResponses, RecoveryFlowServiceSubmitRecoveryFlowData, RecoveryFlowServiceSubmitRecoveryFlowErrors, RecoveryFlowServiceSubmitRecoveryFlowResponses, RegisterFlowServiceInitRegisterFlowData, RegisterFlowServiceInitRegisterFlowErrors, RegisterFlowServiceInitRegisterFlowResponses, RegisterFlowServiceSubmitRegisterData, RegisterFlowServiceSubmitRegisterErrors, RegisterFlowServiceSubmitRegisterResponses, RelyingPartyServiceCreateRelyingPartyData, RelyingPartyServiceCreateRelyingPartyErrors, RelyingPartyServiceCreateRelyingPartyResponses, RelyingPartyServiceDeleteRelyingPartyData, RelyingPartyServiceDeleteRelyingPartyErrors, RelyingPartyServiceDeleteRelyingPartyResponses, RelyingPartyServiceGetRelyingPartyData, RelyingPartyServiceGetRelyingPartyErrors, RelyingPartyServiceGetRelyingPartyResponses, RelyingPartyServiceGrantAccessData, RelyingPartyServiceGrantAccessErrors, RelyingPartyServiceGrantAccessResponses, RelyingPartyServiceListRelyingPartiesData, RelyingPartyServiceListRelyingPartiesErrors, RelyingPartyServiceListRelyingPartiesResponses, RelyingPartyServiceRevokeAccessData, RelyingPartyServiceRevokeAccessErrors, RelyingPartyServiceRevokeAccessResponses, RelyingPartyServiceRotateClientSecretData, RelyingPartyServiceRotateClientSecretErrors, RelyingPartyServiceRotateClientSecretResponses, RelyingPartyServiceUpdateRelyingPartyData, RelyingPartyServiceUpdateRelyingPartyErrors, RelyingPartyServiceUpdateRelyingPartyResponses, ResourceServerServiceCreateClientResourceBindingData, ResourceServerServiceCreateClientResourceBindingErrors, ResourceServerServiceCreateClientResourceBindingResponses, ResourceServerServiceCreateClientRoleAssignmentData, ResourceServerServiceCreateClientRoleAssignmentErrors, ResourceServerServiceCreateClientRoleAssignmentResponses, ResourceServerServiceCreateIntrospectionClientBindingData, ResourceServerServiceCreateIntrospectionClientBindingErrors, ResourceServerServiceCreateIntrospectionClientBindingResponses, ResourceServerServiceCreateResourceServerData, ResourceServerServiceCreateResourceServerErrors, ResourceServerServiceCreateResourceServerResponses, ResourceServerServiceCreateWorkloadBindingData, ResourceServerServiceCreateWorkloadBindingErrors, ResourceServerServiceCreateWorkloadBindingResponses, ResourceServerServiceDeleteClientResourceBindingData, ResourceServerServiceDeleteClientResourceBindingErrors, ResourceServerServiceDeleteClientResourceBindingResponses, ResourceServerServiceDeleteClientRoleAssignmentData, ResourceServerServiceDeleteClientRoleAssignmentErrors, ResourceServerServiceDeleteClientRoleAssignmentResponses, ResourceServerServiceDeleteIntrospectionClientBindingData, ResourceServerServiceDeleteIntrospectionClientBindingErrors, ResourceServerServiceDeleteIntrospectionClientBindingResponses, ResourceServerServiceDeleteResourceServerData, ResourceServerServiceDeleteResourceServerErrors, ResourceServerServiceDeleteResourceServerResponses, ResourceServerServiceDeleteWorkloadBindingData, ResourceServerServiceDeleteWorkloadBindingErrors, ResourceServerServiceDeleteWorkloadBindingResponses, ResourceServerServiceGetResourceServerData, ResourceServerServiceGetResourceServerErrors, ResourceServerServiceGetResourceServerResponses, ResourceServerServiceListClientResourceBindingsData, ResourceServerServiceListClientResourceBindingsErrors, ResourceServerServiceListClientResourceBindingsResponses, ResourceServerServiceListClientRoleAssignmentsData, ResourceServerServiceListClientRoleAssignmentsErrors, ResourceServerServiceListClientRoleAssignmentsResponses, ResourceServerServiceListIntrospectionClientBindingsData, ResourceServerServiceListIntrospectionClientBindingsErrors, ResourceServerServiceListIntrospectionClientBindingsResponses, ResourceServerServiceListResourceServersData, ResourceServerServiceListResourceServersErrors, ResourceServerServiceListResourceServersResponses, ResourceServerServiceListWorkloadBindingsData, ResourceServerServiceListWorkloadBindingsErrors, ResourceServerServiceListWorkloadBindingsResponses, ResourceServerServiceUpdateResourceServerData, ResourceServerServiceUpdateResourceServerErrors, ResourceServerServiceUpdateResourceServerResponses, SamlIdpServiceCreateServiceProviderData, SamlIdpServiceCreateServiceProviderErrors, SamlIdpServiceCreateServiceProviderResponses, SamlIdpServiceDeleteServiceProviderData, SamlIdpServiceDeleteServiceProviderErrors, SamlIdpServiceDeleteServiceProviderResponses, SamlIdpServiceGenerateAssertionData, SamlIdpServiceGenerateAssertionErrors, SamlIdpServiceGenerateAssertionResponses, SamlIdpServiceGetServiceProviderData, SamlIdpServiceGetServiceProviderErrors, SamlIdpServiceGetServiceProviderResponses, SamlIdpServiceListServiceProvidersData, SamlIdpServiceListServiceProvidersErrors, SamlIdpServiceListServiceProvidersResponses, SamlIdpServiceProcessAuthnRequestData, SamlIdpServiceProcessAuthnRequestErrors, SamlIdpServiceProcessAuthnRequestResponses, SamlIdpServiceRenderIdpMetadataData, SamlIdpServiceRenderIdpMetadataErrors, SamlIdpServiceRenderIdpMetadataResponses, SamlIdpServiceResolveServiceProviderData, SamlIdpServiceResolveServiceProviderErrors, SamlIdpServiceResolveServiceProviderResponses, SamlIdpServiceUpdateServiceProviderData, SamlIdpServiceUpdateServiceProviderErrors, SamlIdpServiceUpdateServiceProviderResponses, SamlSpServiceCreateSamlConfigData, SamlSpServiceCreateSamlConfigErrors, SamlSpServiceCreateSamlConfigResponses, SamlSpServiceDeleteSamlConfigData, SamlSpServiceDeleteSamlConfigErrors, SamlSpServiceDeleteSamlConfigResponses, SamlSpServiceGetSamlConfigData, SamlSpServiceGetSamlConfigErrors, SamlSpServiceGetSamlConfigResponses, SamlSpServiceListSamlConfigsData, SamlSpServiceListSamlConfigsErrors, SamlSpServiceListSamlConfigsResponses, SamlSpServiceRenderSamlMetadataData, SamlSpServiceRenderSamlMetadataErrors, SamlSpServiceRenderSamlMetadataResponses, SamlSpServiceUpdateSamlConfigData, SamlSpServiceUpdateSamlConfigErrors, SamlSpServiceUpdateSamlConfigResponses, SchemaServiceActivateSchemaData, SchemaServiceActivateSchemaErrors, SchemaServiceActivateSchemaResponses, SchemaServiceCreateSchemaData, SchemaServiceCreateSchemaErrors, SchemaServiceCreateSchemaResponses, SchemaServiceDeleteSchemaData, SchemaServiceDeleteSchemaErrors, SchemaServiceDeleteSchemaResponses, SchemaServiceDescribeSchemaData, SchemaServiceDescribeSchemaErrors, SchemaServiceDescribeSchemaResponses, SchemaServiceGetSchemaData, SchemaServiceGetSchemaErrors, SchemaServiceGetSchemaResponses, SchemaServiceListSchemasData, SchemaServiceListSchemasErrors, SchemaServiceListSchemasResponses, SchemaServiceResolveActiveSchemaData, SchemaServiceResolveActiveSchemaErrors, SchemaServiceResolveActiveSchemaResponses, SchemaServiceReviseSchemaData, SchemaServiceReviseSchemaErrors, SchemaServiceReviseSchemaResponses, SessionServiceListSessionsData, SessionServiceListSessionsErrors, SessionServiceListSessionsResponses, SessionServiceLogoutAllSessionsData, SessionServiceLogoutAllSessionsErrors, SessionServiceLogoutAllSessionsResponses, SessionServiceLogoutSessionData, SessionServiceLogoutSessionErrors, SessionServiceLogoutSessionResponses, SessionServiceRefreshSessionData, SessionServiceRefreshSessionErrors, SessionServiceRefreshSessionResponses, SessionServiceRevokeSessionData, SessionServiceRevokeSessionErrors, SessionServiceRevokeSessionResponses, SessionServiceValidateSessionData, SessionServiceValidateSessionErrors, SessionServiceValidateSessionResponses, SettingsServiceChangePasswordData, SettingsServiceChangePasswordErrors, SettingsServiceChangePasswordResponses, SettingsServiceChangeProfileData, SettingsServiceChangeProfileErrors, SettingsServiceChangeProfileResponses, SettingsServiceCloseAccountData, SettingsServiceCloseAccountErrors, SettingsServiceCloseAccountResponses, SettingsServiceGenerateRecoveryCodesData, SettingsServiceGenerateRecoveryCodesErrors, SettingsServiceGenerateRecoveryCodesResponses, SettingsServiceInitSettingsFlowData, SettingsServiceInitSettingsFlowErrors, SettingsServiceInitSettingsFlowResponses, SettingsServiceListConsentGrantsData, SettingsServiceListConsentGrantsErrors, SettingsServiceListConsentGrantsResponses, SettingsServiceListCredentialsData, SettingsServiceListCredentialsErrors, SettingsServiceListCredentialsResponses, SettingsServiceListSessionsData, SettingsServiceListSessionsErrors, SettingsServiceListSessionsResponses, SettingsServiceListSocialAccountsData, SettingsServiceListSocialAccountsErrors, SettingsServiceListSocialAccountsResponses, SettingsServiceRemoveCredentialData, SettingsServiceRemoveCredentialErrors, SettingsServiceRemoveCredentialResponses, SettingsServiceRevokeConsentGrantData, SettingsServiceRevokeConsentGrantErrors, SettingsServiceRevokeConsentGrantResponses, SettingsServiceRevokeSessionData, SettingsServiceRevokeSessionErrors, SettingsServiceRevokeSessionResponses, SettingsServiceSubmitSettingsFlowData, SettingsServiceSubmitSettingsFlowErrors, SettingsServiceSubmitSettingsFlowResponses, SettingsServiceUnlinkSocialAccountData, SettingsServiceUnlinkSocialAccountErrors, SettingsServiceUnlinkSocialAccountResponses, SocialProviderServiceCreateSocialProviderData, SocialProviderServiceCreateSocialProviderErrors, SocialProviderServiceCreateSocialProviderResponses, SocialProviderServiceDeleteSocialProviderData, SocialProviderServiceDeleteSocialProviderErrors, SocialProviderServiceDeleteSocialProviderResponses, SocialProviderServiceGetSocialProviderData, SocialProviderServiceGetSocialProviderErrors, SocialProviderServiceGetSocialProviderResponses, SocialProviderServiceListSocialProvidersData, SocialProviderServiceListSocialProvidersErrors, SocialProviderServiceListSocialProvidersResponses, SocialProviderServiceRevokeRetainedSnapshotsData, SocialProviderServiceRevokeRetainedSnapshotsErrors, SocialProviderServiceRevokeRetainedSnapshotsResponses, SocialProviderServiceRevokeRetainedTokensData, SocialProviderServiceRevokeRetainedTokensErrors, SocialProviderServiceRevokeRetainedTokensResponses, SocialProviderServiceRotateSocialProviderSecretData, SocialProviderServiceRotateSocialProviderSecretErrors, SocialProviderServiceRotateSocialProviderSecretResponses, SocialProviderServiceTestSocialProviderData, SocialProviderServiceTestSocialProviderErrors, SocialProviderServiceTestSocialProviderResponses, SocialProviderServiceUpdateSocialProviderData, SocialProviderServiceUpdateSocialProviderErrors, SocialProviderServiceUpdateSocialProviderResponses, TenantServiceActivateTenantData, TenantServiceActivateTenantErrors, TenantServiceActivateTenantResponses, TenantServiceArchiveTenantData, TenantServiceArchiveTenantErrors, TenantServiceArchiveTenantResponses, TenantServiceComputeTenantStatsData, TenantServiceComputeTenantStatsErrors, TenantServiceComputeTenantStatsResponses, TenantServiceCreateTenantData, TenantServiceCreateTenantErrors, TenantServiceCreateTenantResponses, TenantServiceDeleteTenantData, TenantServiceDeleteTenantErrors, TenantServiceDeleteTenantResponses, TenantServiceGetTenantData, TenantServiceGetTenantErrors, TenantServiceGetTenantResponses, TenantServiceListTenantsData, TenantServiceListTenantsErrors, TenantServiceListTenantsResponses, TenantServiceRegisterTenantData, TenantServiceRegisterTenantErrors, TenantServiceRegisterTenantResponses, TenantServiceSuspendTenantData, TenantServiceSuspendTenantErrors, TenantServiceSuspendTenantResponses, TenantServiceUpdateTenantData, TenantServiceUpdateTenantErrors, TenantServiceUpdateTenantResponses, WebhookServiceCreateWebhookData, WebhookServiceCreateWebhookErrors, WebhookServiceCreateWebhookResponses, WebhookServiceDeleteWebhookData, WebhookServiceDeleteWebhookErrors, WebhookServiceDeleteWebhookResponses, WebhookServiceGetWebhookData, WebhookServiceGetWebhookErrors, WebhookServiceGetWebhookResponses, WebhookServiceListWebhooksData, WebhookServiceListWebhooksErrors, WebhookServiceListWebhooksResponses, WebhookServiceTestWebhookData, WebhookServiceTestWebhookErrors, WebhookServiceTestWebhookResponses, WebhookServiceUpdateWebhookData, WebhookServiceUpdateWebhookErrors, WebhookServiceUpdateWebhookResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Handles a bootstrap admin
 *
 * Handles a bootstrap admin.
 */
export const adminServiceBootstrapAdmin = <ThrowOnError extends boolean = false>(options: Options<AdminServiceBootstrapAdminData, ThrowOnError>): RequestResult<AdminServiceBootstrapAdminResponses, AdminServiceBootstrapAdminErrors, ThrowOnError> => (options.client ?? client).post<AdminServiceBootstrapAdminResponses, AdminServiceBootstrapAdminErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/admin:bootstrap',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validates an access token and checks whether the subject has a required
 *
 * Validates an access token and checks whether the subject has a required
 * application permission. This is a fresh database check that reflects
 * role/permission changes immediately, unlike JWT claims which are valid
 * until token expiry.
 *
 * The caller must authenticate as a Relying Party bound to the target Resource Server.
 * IDAAS validates:
 * 1. Caller Relying Party is active and bound to the target Resource Server
 * 2. access_token.aud contains the target Resource Server audience
 * 3. required_permission is an active application permission owned by that Resource Server
 * 4. Token subject/session is still valid
 * 5. Current database role assignments grant the permission and cover the target scope
 *
 * Rate limiting: subject to per-RP and per-IP rate limits. Default policy
 * allows sustained PDP query load (e.g., 1000 req/s per RP) while blocking
 * abuse. Exhausted quotas return RESOURCE_EXHAUSTED / HTTP 429.
 */
export const applicationAuthorizationServiceCheckAccess = <ThrowOnError extends boolean = false>(options: Options<ApplicationAuthorizationServiceCheckAccessData, ThrowOnError>): RequestResult<ApplicationAuthorizationServiceCheckAccessResponses, ApplicationAuthorizationServiceCheckAccessErrors, ThrowOnError> => (options.client ?? client).post<ApplicationAuthorizationServiceCheckAccessResponses, ApplicationAuthorizationServiceCheckAccessErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/applicationAuthorization:checkAccess',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export audit logs across all realms. Only platform-scoped callers are
 *
 * Export audit logs across all realms. Only platform-scoped callers are
 * authorized (AIP-136).
 */
export const auditLogServiceExportPlatformAuditLogs = <ThrowOnError extends boolean = false>(options: Options<AuditLogServiceExportPlatformAuditLogsData, ThrowOnError>): RequestResult<AuditLogServiceExportPlatformAuditLogsResponses, AuditLogServiceExportPlatformAuditLogsErrors, ThrowOnError> => (options.client ?? client).post<AuditLogServiceExportPlatformAuditLogsResponses, AuditLogServiceExportPlatformAuditLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/auditExports:exportPlatformAuditLogs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Query audit logs across all realms. Only platform-scoped callers are
 *
 * Query audit logs across all realms. Only platform-scoped callers are
 * authorized (AIP-136).
 */
export const auditLogServiceQueryPlatformAuditLogs = <ThrowOnError extends boolean = false>(options?: Options<AuditLogServiceQueryPlatformAuditLogsData, ThrowOnError>): RequestResult<AuditLogServiceQueryPlatformAuditLogsResponses, AuditLogServiceQueryPlatformAuditLogsErrors, ThrowOnError> => (options?.client ?? client).get<AuditLogServiceQueryPlatformAuditLogsResponses, AuditLogServiceQueryPlatformAuditLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/auditLogs:query',
    ...options
});

/**
 * Compute audit statistics across all realms. Only platform-scoped callers
 *
 * Compute audit statistics across all realms. Only platform-scoped callers
 * are authorized (AIP-136).
 */
export const auditLogServiceSummarizePlatformAuditStats = <ThrowOnError extends boolean = false>(options?: Options<AuditLogServiceSummarizePlatformAuditStatsData, ThrowOnError>): RequestResult<AuditLogServiceSummarizePlatformAuditStatsResponses, AuditLogServiceSummarizePlatformAuditStatsErrors, ThrowOnError> => (options?.client ?? client).get<AuditLogServiceSummarizePlatformAuditStatsResponses, AuditLogServiceSummarizePlatformAuditStatsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/auditStats:summarize',
    ...options
});

/**
 * Submits one authentication step to a login flow. Successful password-only
 *
 * Submits one authentication step to a login flow. Successful password-only
 * authentication returns session tokens; MFA step-up returns state=CONTINUE
 * and available_methods for the next step.
 */
export const loginFlowServiceSubmitLogin = <ThrowOnError extends boolean = false>(options: Options<LoginFlowServiceSubmitLoginData, ThrowOnError>): RequestResult<LoginFlowServiceSubmitLoginResponses, LoginFlowServiceSubmitLoginErrors, ThrowOnError> => (options.client ?? client).post<LoginFlowServiceSubmitLoginResponses, LoginFlowServiceSubmitLoginErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/login/flows/{flow}:submitLogin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates a short-lived login flow for a realm
 *
 * Creates a short-lived login flow for a realm.
 */
export const loginFlowServiceInitLoginFlow = <ThrowOnError extends boolean = false>(options: Options<LoginFlowServiceInitLoginFlowData, ThrowOnError>): RequestResult<LoginFlowServiceInitLoginFlowResponses, LoginFlowServiceInitLoginFlowErrors, ThrowOnError> => (options.client ?? client).post<LoginFlowServiceInitLoginFlowResponses, LoginFlowServiceInitLoginFlowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/login/flows:initLoginFlow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolves client routing metadata for the gateway. This is not an OAuth
 *
 * Resolves client routing metadata for the gateway. This is not an OAuth
 * standard endpoint, so it stays under the business API prefix.
 */
export const oidcProviderServiceResolveClientInfo = <ThrowOnError extends boolean = false>(options?: Options<OidcProviderServiceResolveClientInfoData, ThrowOnError>): RequestResult<OidcProviderServiceResolveClientInfoResponses, OidcProviderServiceResolveClientInfoErrors, ThrowOnError> => (options?.client ?? client).get<OidcProviderServiceResolveClientInfoResponses, OidcProviderServiceResolveClientInfoErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/oauth2/clients:resolveClientInfo',
    ...options
});

/**
 * Export the audit log of one realm as encoded bytes. Large exports should
 *
 * Export the audit log of one realm as encoded bytes. Large exports should
 * be moved to an async job before this endpoint is exposed to high-volume
 * tenants (AIP-136).
 */
export const auditLogServiceExportAuditLogs = <ThrowOnError extends boolean = false>(options: Options<AuditLogServiceExportAuditLogsData, ThrowOnError>): RequestResult<AuditLogServiceExportAuditLogsResponses, AuditLogServiceExportAuditLogsErrors, ThrowOnError> => (options.client ?? client).post<AuditLogServiceExportAuditLogsResponses, AuditLogServiceExportAuditLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/auditExports:export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Query the audit log of one realm with time-range filters and cursor
 *
 * Query the audit log of one realm with time-range filters and cursor
 * pagination (AIP-136).
 */
export const auditLogServiceQueryAuditLogs = <ThrowOnError extends boolean = false>(options: Options<AuditLogServiceQueryAuditLogsData, ThrowOnError>): RequestResult<AuditLogServiceQueryAuditLogsResponses, AuditLogServiceQueryAuditLogsErrors, ThrowOnError> => (options.client ?? client).get<AuditLogServiceQueryAuditLogsResponses, AuditLogServiceQueryAuditLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/auditLogs:query',
    ...options
});

/**
 * Compute audit statistics of one realm (AIP-136)
 *
 * Compute audit statistics of one realm (AIP-136).
 */
export const auditLogServiceSummarizeAuditStats = <ThrowOnError extends boolean = false>(options: Options<AuditLogServiceSummarizeAuditStatsData, ThrowOnError>): RequestResult<AuditLogServiceSummarizeAuditStatsResponses, AuditLogServiceSummarizeAuditStatsErrors, ThrowOnError> => (options.client ?? client).get<AuditLogServiceSummarizeAuditStatsResponses, AuditLogServiceSummarizeAuditStatsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/auditStats:summarize',
    ...options
});

/**
 * Lists deny-list entries under a realm
 *
 * Lists deny-list entries under a realm.
 */
export const rateLimitServiceListBlacklistEntries = <ThrowOnError extends boolean = false>(options: Options<RateLimitServiceListBlacklistEntriesData, ThrowOnError>): RequestResult<RateLimitServiceListBlacklistEntriesResponses, RateLimitServiceListBlacklistEntriesErrors, ThrowOnError> => (options.client ?? client).get<RateLimitServiceListBlacklistEntriesResponses, RateLimitServiceListBlacklistEntriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/blacklistEntries',
    ...options
});

/**
 * Adds an IP or CIDR range to the realm deny list
 *
 * Adds an IP or CIDR range to the realm deny list.
 */
export const rateLimitServiceCreateBlacklistEntry = <ThrowOnError extends boolean = false>(options: Options<RateLimitServiceCreateBlacklistEntryData, ThrowOnError>): RequestResult<RateLimitServiceCreateBlacklistEntryResponses, RateLimitServiceCreateBlacklistEntryErrors, ThrowOnError> => (options.client ?? client).post<RateLimitServiceCreateBlacklistEntryResponses, RateLimitServiceCreateBlacklistEntryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/blacklistEntries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes an entry from the realm deny list
 *
 * Removes an entry from the realm deny list.
 */
export const rateLimitServiceDeleteBlacklistEntry = <ThrowOnError extends boolean = false>(options: Options<RateLimitServiceDeleteBlacklistEntryData, ThrowOnError>): RequestResult<RateLimitServiceDeleteBlacklistEntryResponses, RateLimitServiceDeleteBlacklistEntryErrors, ThrowOnError> => (options.client ?? client).delete<RateLimitServiceDeleteBlacklistEntryResponses, RateLimitServiceDeleteBlacklistEntryErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/blacklistEntries/{blacklistEntry}',
    ...options
});

/**
 * Gets one deny-list entry by resource name
 *
 * Gets one deny-list entry by resource name.
 */
export const rateLimitServiceGetBlacklistEntry = <ThrowOnError extends boolean = false>(options: Options<RateLimitServiceGetBlacklistEntryData, ThrowOnError>): RequestResult<RateLimitServiceGetBlacklistEntryResponses, RateLimitServiceGetBlacklistEntryErrors, ThrowOnError> => (options.client ?? client).get<RateLimitServiceGetBlacklistEntryResponses, RateLimitServiceGetBlacklistEntryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/blacklistEntries/{blacklistEntry}',
    ...options
});

/**
 * Lists delegated authorizations in one realm; `filter` supports exact
 *
 * Lists delegated authorizations in one realm; `filter` supports exact
 * `session_id = "<uuid>"`, `authorized_party_id = "<uuid>"`, or
 * `resource_server_id = "<uuid>"` matches.
 */
export const delegatedAuthorizationServiceListDelegatedAuthorizations = <ThrowOnError extends boolean = false>(options: Options<DelegatedAuthorizationServiceListDelegatedAuthorizationsData, ThrowOnError>): RequestResult<DelegatedAuthorizationServiceListDelegatedAuthorizationsResponses, DelegatedAuthorizationServiceListDelegatedAuthorizationsErrors, ThrowOnError> => (options.client ?? client).get<DelegatedAuthorizationServiceListDelegatedAuthorizationsResponses, DelegatedAuthorizationServiceListDelegatedAuthorizationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/delegatedAuthorizations',
    ...options
});

/**
 * Reads one delegated authorization
 *
 * Reads one delegated authorization.
 */
export const delegatedAuthorizationServiceGetDelegatedAuthorization = <ThrowOnError extends boolean = false>(options: Options<DelegatedAuthorizationServiceGetDelegatedAuthorizationData, ThrowOnError>): RequestResult<DelegatedAuthorizationServiceGetDelegatedAuthorizationResponses, DelegatedAuthorizationServiceGetDelegatedAuthorizationErrors, ThrowOnError> => (options.client ?? client).get<DelegatedAuthorizationServiceGetDelegatedAuthorizationResponses, DelegatedAuthorizationServiceGetDelegatedAuthorizationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/delegatedAuthorizations/{delegatedAuthorization}',
    ...options
});

/**
 * Revokes one delegated authorization
 *
 * Revokes one delegated authorization.
 */
export const delegatedAuthorizationServiceRevokeDelegatedAuthorization = <ThrowOnError extends boolean = false>(options: Options<DelegatedAuthorizationServiceRevokeDelegatedAuthorizationData, ThrowOnError>): RequestResult<DelegatedAuthorizationServiceRevokeDelegatedAuthorizationResponses, DelegatedAuthorizationServiceRevokeDelegatedAuthorizationErrors, ThrowOnError> => (options.client ?? client).post<DelegatedAuthorizationServiceRevokeDelegatedAuthorizationResponses, DelegatedAuthorizationServiceRevokeDelegatedAuthorizationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/delegatedAuthorizations/{delegatedAuthorization}:revoke',
    ...options
});

/**
 * Lists identities in a realm with pagination and optional filters
 *
 * Lists identities in a realm with pagination and optional filters.
 */
export const identityServiceListIdentities = <ThrowOnError extends boolean = false>(options: Options<IdentityServiceListIdentitiesData, ThrowOnError>): RequestResult<IdentityServiceListIdentitiesResponses, IdentityServiceListIdentitiesErrors, ThrowOnError> => (options.client ?? client).get<IdentityServiceListIdentitiesResponses, IdentityServiceListIdentitiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities',
    ...options
});

/**
 * Creates an identity in a realm. This is an administrative operation;
 *
 * Creates an identity in a realm. This is an administrative operation;
 * public sign-up flows should use the registration flow service so
 * anti-abuse and credential setup policies are applied consistently.
 */
export const identityServiceCreateIdentity = <ThrowOnError extends boolean = false>(options: Options<IdentityServiceCreateIdentityData, ThrowOnError>): RequestResult<IdentityServiceCreateIdentityResponses, IdentityServiceCreateIdentityErrors, ThrowOnError> => (options.client ?? client).post<IdentityServiceCreateIdentityResponses, IdentityServiceCreateIdentityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets an identity by resource name
 *
 * Gets an identity by resource name.
 */
export const identityServiceGetIdentity = <ThrowOnError extends boolean = false>(options: Options<IdentityServiceGetIdentityData, ThrowOnError>): RequestResult<IdentityServiceGetIdentityResponses, IdentityServiceGetIdentityErrors, ThrowOnError> => (options.client ?? client).get<IdentityServiceGetIdentityResponses, IdentityServiceGetIdentityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}',
    ...options
});

/**
 * Lists the non-secret credential summaries bound to an identity
 *
 * Lists the non-secret credential summaries bound to an identity.
 */
export const identityServiceListCredentials = <ThrowOnError extends boolean = false>(options: Options<IdentityServiceListCredentialsData, ThrowOnError>): RequestResult<IdentityServiceListCredentialsResponses, IdentityServiceListCredentialsErrors, ThrowOnError> => (options.client ?? client).get<IdentityServiceListCredentialsResponses, IdentityServiceListCredentialsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/credentials',
    ...options
});

/**
 * ⚠️ **Not yet implemented** — returns gRPC UNIMPLEMENTED
 *
 * ⚠️ **Not yet implemented** — returns gRPC UNIMPLEMENTED.
 *
 * Evaluates whether an identity can perform an action on a resource. This is
 * a custom action endpoint because it computes a decision rather than
 * reading a stored access-control resource.
 */
export const accessControlServiceCheckPermission = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceCheckPermissionData, ThrowOnError>): RequestResult<AccessControlServiceCheckPermissionResponses, AccessControlServiceCheckPermissionErrors, ThrowOnError> => (options.client ?? client).post<AccessControlServiceCheckPermissionResponses, AccessControlServiceCheckPermissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/permissions:checkPermission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assigns a role to an identity
 *
 * Assigns a role to an identity.
 */
export const accessControlServiceAssignRole = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceAssignRoleData, ThrowOnError>): RequestResult<AccessControlServiceAssignRoleResponses, AccessControlServiceAssignRoleErrors, ThrowOnError> => (options.client ?? client).post<AccessControlServiceAssignRoleResponses, AccessControlServiceAssignRoleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/roles:assignRole',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revokes a role assignment from an identity
 *
 * Revokes a role assignment from an identity.
 */
export const accessControlServiceRevokeRole = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceRevokeRoleData, ThrowOnError>): RequestResult<AccessControlServiceRevokeRoleResponses, AccessControlServiceRevokeRoleErrors, ThrowOnError> => (options.client ?? client).post<AccessControlServiceRevokeRoleResponses, AccessControlServiceRevokeRoleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/roles:revokeRole',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists active sessions for an identity
 *
 * Lists active sessions for an identity.
 */
export const sessionServiceListSessions = <ThrowOnError extends boolean = false>(options: Options<SessionServiceListSessionsData, ThrowOnError>): RequestResult<SessionServiceListSessionsResponses, SessionServiceListSessionsErrors, ThrowOnError> => (options.client ?? client).get<SessionServiceListSessionsResponses, SessionServiceListSessionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/sessions',
    ...options
});

/**
 * Revokes all sessions for an identity, optionally preserving one session
 *
 * Revokes all sessions for an identity, optionally preserving one session.
 */
export const sessionServiceLogoutAllSessions = <ThrowOnError extends boolean = false>(options: Options<SessionServiceLogoutAllSessionsData, ThrowOnError>): RequestResult<SessionServiceLogoutAllSessionsResponses, SessionServiceLogoutAllSessionsErrors, ThrowOnError> => (options.client ?? client).post<SessionServiceLogoutAllSessionsResponses, SessionServiceLogoutAllSessionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/sessions:logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists active durable OAuth/OIDC consent grants of the authenticated
 *
 * Lists active durable OAuth/OIDC consent grants of the authenticated
 * identity.
 */
export const settingsServiceListConsentGrants = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceListConsentGrantsData, ThrowOnError>): RequestResult<SettingsServiceListConsentGrantsResponses, SettingsServiceListConsentGrantsErrors, ThrowOnError> => (options.client ?? client).get<SettingsServiceListConsentGrantsResponses, SettingsServiceListConsentGrantsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings/consentGrants',
    ...options
});

/**
 * Revokes one owned OAuth/OIDC consent grant and its refresh-token
 *
 * Revokes one owned OAuth/OIDC consent grant and its refresh-token
 * families.
 */
export const settingsServiceRevokeConsentGrant = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceRevokeConsentGrantData, ThrowOnError>): RequestResult<SettingsServiceRevokeConsentGrantResponses, SettingsServiceRevokeConsentGrantErrors, ThrowOnError> => (options.client ?? client).post<SettingsServiceRevokeConsentGrantResponses, SettingsServiceRevokeConsentGrantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings/consentGrants:revokeConsentGrant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the credentials of the authenticated identity
 *
 * Lists the credentials of the authenticated identity.
 */
export const settingsServiceListCredentials = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceListCredentialsData, ThrowOnError>): RequestResult<SettingsServiceListCredentialsResponses, SettingsServiceListCredentialsErrors, ThrowOnError> => (options.client ?? client).get<SettingsServiceListCredentialsResponses, SettingsServiceListCredentialsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings/credentials',
    ...options
});

/**
 * Removes a credential after proving ownership with the current password
 *
 * Removes a credential after proving ownership with the current password.
 * The service rejects removal when it would leave the account without any
 * usable login method.
 */
export const settingsServiceRemoveCredential = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceRemoveCredentialData, ThrowOnError>): RequestResult<SettingsServiceRemoveCredentialResponses, SettingsServiceRemoveCredentialErrors, ThrowOnError> => (options.client ?? client).post<SettingsServiceRemoveCredentialResponses, SettingsServiceRemoveCredentialErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings/credentials:removeCredential',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Initializes a settings flow for the authenticated identity and returns
 *
 * Initializes a settings flow for the authenticated identity and returns
 * the methods the identity may submit, such as PASSWORD, TOTP, WEB_AUTHN,
 * or OIDC_LINK.
 */
export const settingsServiceInitSettingsFlow = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceInitSettingsFlowData, ThrowOnError>): RequestResult<SettingsServiceInitSettingsFlowResponses, SettingsServiceInitSettingsFlowErrors, ThrowOnError> => (options.client ?? client).post<SettingsServiceInitSettingsFlowResponses, SettingsServiceInitSettingsFlowErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings/flows:initSettingsFlow',
    ...options
});

/**
 * Submits a settings flow step, such as TOTP enrollment or OIDC account
 *
 * Submits a settings flow step, such as TOTP enrollment or OIDC account
 * link.
 */
export const settingsServiceSubmitSettingsFlow = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceSubmitSettingsFlowData, ThrowOnError>): RequestResult<SettingsServiceSubmitSettingsFlowResponses, SettingsServiceSubmitSettingsFlowErrors, ThrowOnError> => (options.client ?? client).post<SettingsServiceSubmitSettingsFlowResponses, SettingsServiceSubmitSettingsFlowErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings/flows:submitSettingsFlow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the sessions of the authenticated identity
 *
 * Lists the sessions of the authenticated identity.
 */
export const settingsServiceListSessions = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceListSessionsData, ThrowOnError>): RequestResult<SettingsServiceListSessionsResponses, SettingsServiceListSessionsErrors, ThrowOnError> => (options.client ?? client).get<SettingsServiceListSessionsResponses, SettingsServiceListSessionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings/sessions',
    ...options
});

/**
 * Revokes one session of the authenticated identity; the current session
 *
 * Revokes one session of the authenticated identity; the current session
 * cannot be revoked through this endpoint.
 */
export const settingsServiceRevokeSession = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceRevokeSessionData, ThrowOnError>): RequestResult<SettingsServiceRevokeSessionResponses, SettingsServiceRevokeSessionErrors, ThrowOnError> => (options.client ?? client).post<SettingsServiceRevokeSessionResponses, SettingsServiceRevokeSessionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings/sessions:revokeSession',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists social-login accounts linked to the authenticated identity
 *
 * Lists social-login accounts linked to the authenticated identity.
 */
export const settingsServiceListSocialAccounts = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceListSocialAccountsData, ThrowOnError>): RequestResult<SettingsServiceListSocialAccountsResponses, SettingsServiceListSocialAccountsErrors, ThrowOnError> => (options.client ?? client).get<SettingsServiceListSocialAccountsResponses, SettingsServiceListSocialAccountsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings/socialAccounts',
    ...options
});

/**
 * Unlinks a social-login account. The service rejects unlinking the last
 *
 * Unlinks a social-login account. The service rejects unlinking the last
 * usable sign-in method.
 */
export const settingsServiceUnlinkSocialAccount = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceUnlinkSocialAccountData, ThrowOnError>): RequestResult<SettingsServiceUnlinkSocialAccountResponses, SettingsServiceUnlinkSocialAccountErrors, ThrowOnError> => (options.client ?? client).post<SettingsServiceUnlinkSocialAccountResponses, SettingsServiceUnlinkSocialAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings/socialAccounts:unlinkSocialAccount',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes the password after verifying the current password
 *
 * Changes the password after verifying the current password.
 */
export const settingsServiceChangePassword = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceChangePasswordData, ThrowOnError>): RequestResult<SettingsServiceChangePasswordResponses, SettingsServiceChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<SettingsServiceChangePasswordResponses, SettingsServiceChangePasswordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings:changePassword',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes the authenticated identity's schema-validated profile traits
 *
 * Changes the authenticated identity's schema-validated profile traits.
 */
export const settingsServiceChangeProfile = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceChangeProfileData, ThrowOnError>): RequestResult<SettingsServiceChangeProfileResponses, SettingsServiceChangeProfileErrors, ThrowOnError> => (options.client ?? client).post<SettingsServiceChangeProfileResponses, SettingsServiceChangeProfileErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings:changeProfile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Closes (deletes) the authenticated account after password confirmation
 *
 * Closes (deletes) the authenticated account after password confirmation.
 * Soft delete is the default; hard delete requires stronger authorization in
 * the application layer.
 */
export const settingsServiceCloseAccount = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceCloseAccountData, ThrowOnError>): RequestResult<SettingsServiceCloseAccountResponses, SettingsServiceCloseAccountErrors, ThrowOnError> => (options.client ?? client).post<SettingsServiceCloseAccountResponses, SettingsServiceCloseAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings:closeAccount',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replaces the authenticated identity's emergency MFA recovery-code set
 *
 * Replaces the authenticated identity's emergency MFA recovery-code set.
 * The response returns the plaintext codes exactly once and the server
 * persists only keyed hashes.
 */
export const settingsServiceGenerateRecoveryCodes = <ThrowOnError extends boolean = false>(options: Options<SettingsServiceGenerateRecoveryCodesData, ThrowOnError>): RequestResult<SettingsServiceGenerateRecoveryCodesResponses, SettingsServiceGenerateRecoveryCodesErrors, ThrowOnError> => (options.client ?? client).post<SettingsServiceGenerateRecoveryCodesResponses, SettingsServiceGenerateRecoveryCodesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}/settings:generateRecoveryCodes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activates an inactive identity after the realm activation policy passes
 *
 * Activates an inactive identity after the realm activation policy passes.
 */
export const identityServiceActivateIdentity = <ThrowOnError extends boolean = false>(options: Options<IdentityServiceActivateIdentityData, ThrowOnError>): RequestResult<IdentityServiceActivateIdentityResponses, IdentityServiceActivateIdentityErrors, ThrowOnError> => (options.client ?? client).post<IdentityServiceActivateIdentityResponses, IdentityServiceActivateIdentityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}:activate',
    ...options
});

/**
 * Disables an active identity; disabled identities cannot authenticate
 *
 * Disables an active identity; disabled identities cannot authenticate.
 */
export const identityServiceDisableIdentity = <ThrowOnError extends boolean = false>(options: Options<IdentityServiceDisableIdentityData, ThrowOnError>): RequestResult<IdentityServiceDisableIdentityResponses, IdentityServiceDisableIdentityErrors, ThrowOnError> => (options.client ?? client).post<IdentityServiceDisableIdentityResponses, IdentityServiceDisableIdentityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/identities/{identity}:disable',
    ...options
});

/**
 * Lists system permissions plus application permissions assignable in the
 *
 * Lists system permissions plus application permissions assignable in the
 * tenant that owns the requested realm.
 */
export const accessControlServiceListPermissions = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceListPermissionsData, ThrowOnError>): RequestResult<AccessControlServiceListPermissionsResponses, AccessControlServiceListPermissionsErrors, ThrowOnError> => (options.client ?? client).get<AccessControlServiceListPermissionsResponses, AccessControlServiceListPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/permissions',
    ...options
});

/**
 * Lists relying parties under a realm using cursor pagination. Filter by
 *
 * Lists relying parties under a realm using cursor pagination. Filter by
 * client posture with `relying_party_type = WEB`.
 */
export const relyingPartyServiceListRelyingParties = <ThrowOnError extends boolean = false>(options: Options<RelyingPartyServiceListRelyingPartiesData, ThrowOnError>): RequestResult<RelyingPartyServiceListRelyingPartiesResponses, RelyingPartyServiceListRelyingPartiesErrors, ThrowOnError> => (options.client ?? client).get<RelyingPartyServiceListRelyingPartiesResponses, RelyingPartyServiceListRelyingPartiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/relyingParties',
    ...options
});

/**
 * Creates a relying party under a realm. For confidential clients the
 *
 * Creates a relying party under a realm. For confidential clients the
 * generated `client_secret` is returned exactly once in the response.
 */
export const relyingPartyServiceCreateRelyingParty = <ThrowOnError extends boolean = false>(options: Options<RelyingPartyServiceCreateRelyingPartyData, ThrowOnError>): RequestResult<RelyingPartyServiceCreateRelyingPartyResponses, RelyingPartyServiceCreateRelyingPartyErrors, ThrowOnError> => (options.client ?? client).post<RelyingPartyServiceCreateRelyingPartyResponses, RelyingPartyServiceCreateRelyingPartyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/relyingParties',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a relying party, returning the deleted aggregate. Existing
 *
 * Deletes a relying party, returning the deleted aggregate. Existing
 * sessions and authorizations are revoked by application-layer policy.
 */
export const relyingPartyServiceDeleteRelyingParty = <ThrowOnError extends boolean = false>(options: Options<RelyingPartyServiceDeleteRelyingPartyData, ThrowOnError>): RequestResult<RelyingPartyServiceDeleteRelyingPartyResponses, RelyingPartyServiceDeleteRelyingPartyErrors, ThrowOnError> => (options.client ?? client).delete<RelyingPartyServiceDeleteRelyingPartyResponses, RelyingPartyServiceDeleteRelyingPartyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/relyingParties/{relyingParty}',
    ...options
});

/**
 * Gets a relying party by resource name
 *
 * Gets a relying party by resource name.
 */
export const relyingPartyServiceGetRelyingParty = <ThrowOnError extends boolean = false>(options: Options<RelyingPartyServiceGetRelyingPartyData, ThrowOnError>): RequestResult<RelyingPartyServiceGetRelyingPartyResponses, RelyingPartyServiceGetRelyingPartyErrors, ThrowOnError> => (options.client ?? client).get<RelyingPartyServiceGetRelyingPartyResponses, RelyingPartyServiceGetRelyingPartyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/relyingParties/{relyingParty}',
    ...options
});

/**
 * Updates a relying party's mutable metadata and configuration
 *
 * Updates a relying party's mutable metadata and configuration.
 */
export const relyingPartyServiceUpdateRelyingParty = <ThrowOnError extends boolean = false>(options: Options<RelyingPartyServiceUpdateRelyingPartyData, ThrowOnError>): RequestResult<RelyingPartyServiceUpdateRelyingPartyResponses, RelyingPartyServiceUpdateRelyingPartyErrors, ThrowOnError> => (options.client ?? client).patch<RelyingPartyServiceUpdateRelyingPartyResponses, RelyingPartyServiceUpdateRelyingPartyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/relyingParties/{relyingParty}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Grants a subject access to the relying party
 *
 * Grants a subject access to the relying party.
 */
export const relyingPartyServiceGrantAccess = <ThrowOnError extends boolean = false>(options: Options<RelyingPartyServiceGrantAccessData, ThrowOnError>): RequestResult<RelyingPartyServiceGrantAccessResponses, RelyingPartyServiceGrantAccessErrors, ThrowOnError> => (options.client ?? client).post<RelyingPartyServiceGrantAccessResponses, RelyingPartyServiceGrantAccessErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/relyingParties/{relyingParty}:grantAccess',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revokes a previously granted subject's access to the relying party
 *
 * Revokes a previously granted subject's access to the relying party.
 */
export const relyingPartyServiceRevokeAccess = <ThrowOnError extends boolean = false>(options: Options<RelyingPartyServiceRevokeAccessData, ThrowOnError>): RequestResult<RelyingPartyServiceRevokeAccessResponses, RelyingPartyServiceRevokeAccessErrors, ThrowOnError> => (options.client ?? client).post<RelyingPartyServiceRevokeAccessResponses, RelyingPartyServiceRevokeAccessErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/relyingParties/{relyingParty}:revokeAccess',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotates the client secret and returns the new plaintext exactly once
 *
 * Rotates the client secret and returns the new plaintext exactly once.
 * Clients must store it immediately; it cannot be read again.
 */
export const relyingPartyServiceRotateClientSecret = <ThrowOnError extends boolean = false>(options: Options<RelyingPartyServiceRotateClientSecretData, ThrowOnError>): RequestResult<RelyingPartyServiceRotateClientSecretResponses, RelyingPartyServiceRotateClientSecretErrors, ThrowOnError> => (options.client ?? client).post<RelyingPartyServiceRotateClientSecretResponses, RelyingPartyServiceRotateClientSecretErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/relyingParties/{relyingParty}:rotateClientSecret',
    ...options
});

/**
 * List resource servers of one realm (AIP-132, AIP-158)
 *
 * List resource servers of one realm (AIP-132, AIP-158).
 */
export const resourceServerServiceListResourceServers = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceListResourceServersData, ThrowOnError>): RequestResult<ResourceServerServiceListResourceServersResponses, ResourceServerServiceListResourceServersErrors, ThrowOnError> => (options.client ?? client).get<ResourceServerServiceListResourceServersResponses, ResourceServerServiceListResourceServersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers',
    ...options
});

/**
 * Create one resource server (AIP-133)
 *
 * Create one resource server (AIP-133).
 */
export const resourceServerServiceCreateResourceServer = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceCreateResourceServerData, ThrowOnError>): RequestResult<ResourceServerServiceCreateResourceServerResponses, ResourceServerServiceCreateResourceServerErrors, ThrowOnError> => (options.client ?? client).post<ResourceServerServiceCreateResourceServerResponses, ResourceServerServiceCreateResourceServerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete one resource server (AIP-135)
 *
 * Delete one resource server (AIP-135).
 */
export const resourceServerServiceDeleteResourceServer = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceDeleteResourceServerData, ThrowOnError>): RequestResult<ResourceServerServiceDeleteResourceServerResponses, ResourceServerServiceDeleteResourceServerErrors, ThrowOnError> => (options.client ?? client).delete<ResourceServerServiceDeleteResourceServerResponses, ResourceServerServiceDeleteResourceServerErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}',
    ...options
});

/**
 * Get one resource server (AIP-131)
 *
 * Get one resource server (AIP-131).
 */
export const resourceServerServiceGetResourceServer = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceGetResourceServerData, ThrowOnError>): RequestResult<ResourceServerServiceGetResourceServerResponses, ResourceServerServiceGetResourceServerErrors, ThrowOnError> => (options.client ?? client).get<ResourceServerServiceGetResourceServerResponses, ResourceServerServiceGetResourceServerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}',
    ...options
});

/**
 * Update one resource server (AIP-134)
 *
 * Update one resource server (AIP-134).
 */
export const resourceServerServiceUpdateResourceServer = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceUpdateResourceServerData, ThrowOnError>): RequestResult<ResourceServerServiceUpdateResourceServerResponses, ResourceServerServiceUpdateResourceServerErrors, ThrowOnError> => (options.client ?? client).patch<ResourceServerServiceUpdateResourceServerResponses, ResourceServerServiceUpdateResourceServerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists application permissions owned by a Resource Server
 *
 * Lists application permissions owned by a Resource Server.
 * Requires system permissions: role:update and resource_server:update.
 */
export const accessControlServiceListApplicationPermissions = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceListApplicationPermissionsData, ThrowOnError>): RequestResult<AccessControlServiceListApplicationPermissionsResponses, AccessControlServiceListApplicationPermissionsErrors, ThrowOnError> => (options.client ?? client).get<AccessControlServiceListApplicationPermissionsResponses, AccessControlServiceListApplicationPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/applicationPermissions',
    ...options
});

/**
 * Creates a new application permission owned by a Resource Server
 *
 * Creates a new application permission owned by a Resource Server.
 * Requires system permissions: role:update and resource_server:update.
 */
export const accessControlServiceCreateApplicationPermission = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceCreateApplicationPermissionData, ThrowOnError>): RequestResult<AccessControlServiceCreateApplicationPermissionResponses, AccessControlServiceCreateApplicationPermissionErrors, ThrowOnError> => (options.client ?? client).post<AccessControlServiceCreateApplicationPermissionResponses, AccessControlServiceCreateApplicationPermissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/applicationPermissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-deletes an application permission. Existing role attachments remain
 *
 * Soft-deletes an application permission. Existing role attachments remain
 * but the permission cannot be attached to new roles.
 * Requires system permissions: role:update and resource_server:update.
 */
export const accessControlServiceDeleteApplicationPermission = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceDeleteApplicationPermissionData, ThrowOnError>): RequestResult<AccessControlServiceDeleteApplicationPermissionResponses, AccessControlServiceDeleteApplicationPermissionErrors, ThrowOnError> => (options.client ?? client).delete<AccessControlServiceDeleteApplicationPermissionResponses, AccessControlServiceDeleteApplicationPermissionErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/applicationPermissions/{applicationPermission}',
    ...options
});

/**
 * Gets one application permission by resource name
 *
 * Gets one application permission by resource name.
 * Requires system permissions: role:read and resource_server:read.
 */
export const accessControlServiceGetApplicationPermission = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceGetApplicationPermissionData, ThrowOnError>): RequestResult<AccessControlServiceGetApplicationPermissionResponses, AccessControlServiceGetApplicationPermissionErrors, ThrowOnError> => (options.client ?? client).get<AccessControlServiceGetApplicationPermissionResponses, AccessControlServiceGetApplicationPermissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/applicationPermissions/{applicationPermission}',
    ...options
});

/**
 * Updates an application permission's description or assignable flag
 *
 * Updates an application permission's description or assignable flag.
 * Requires system permissions: role:update and resource_server:update.
 */
export const accessControlServiceUpdateApplicationPermission = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceUpdateApplicationPermissionData, ThrowOnError>): RequestResult<AccessControlServiceUpdateApplicationPermissionResponses, AccessControlServiceUpdateApplicationPermissionErrors, ThrowOnError> => (options.client ?? client).patch<AccessControlServiceUpdateApplicationPermissionResponses, AccessControlServiceUpdateApplicationPermissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/applicationPermissions/{applicationPermission}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List client trust bindings of one resource server (AIP-132, AIP-158)
 *
 * List client trust bindings of one resource server (AIP-132, AIP-158).
 */
export const resourceServerServiceListClientResourceBindings = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceListClientResourceBindingsData, ThrowOnError>): RequestResult<ResourceServerServiceListClientResourceBindingsResponses, ResourceServerServiceListClientResourceBindingsErrors, ThrowOnError> => (options.client ?? client).get<ResourceServerServiceListClientResourceBindingsResponses, ResourceServerServiceListClientResourceBindingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/clients',
    ...options
});

/**
 * Create or replace one client trust binding; the resource-server/client
 *
 * Create or replace one client trust binding; the resource-server/client
 * pair is the identity, so the create is idempotent (AIP-133).
 */
export const resourceServerServiceCreateClientResourceBinding = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceCreateClientResourceBindingData, ThrowOnError>): RequestResult<ResourceServerServiceCreateClientResourceBindingResponses, ResourceServerServiceCreateClientResourceBindingErrors, ThrowOnError> => (options.client ?? client).post<ResourceServerServiceCreateClientResourceBindingResponses, ResourceServerServiceCreateClientResourceBindingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/clients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete one client trust binding (AIP-135)
 *
 * Delete one client trust binding (AIP-135).
 */
export const resourceServerServiceDeleteClientResourceBinding = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceDeleteClientResourceBindingData, ThrowOnError>): RequestResult<ResourceServerServiceDeleteClientResourceBindingResponses, ResourceServerServiceDeleteClientResourceBindingErrors, ThrowOnError> => (options.client ?? client).delete<ResourceServerServiceDeleteClientResourceBindingResponses, ResourceServerServiceDeleteClientResourceBindingErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/clients/{client}',
    ...options
});

/**
 * List client role assignments of one bound client (AIP-132, AIP-158)
 *
 * List client role assignments of one bound client (AIP-132, AIP-158).
 */
export const resourceServerServiceListClientRoleAssignments = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceListClientRoleAssignmentsData, ThrowOnError>): RequestResult<ResourceServerServiceListClientRoleAssignmentsResponses, ResourceServerServiceListClientRoleAssignmentsErrors, ThrowOnError> => (options.client ?? client).get<ResourceServerServiceListClientRoleAssignmentsResponses, ResourceServerServiceListClientRoleAssignmentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/clients/{client}/roleAssignments',
    ...options
});

/**
 * Create one client role assignment (AIP-133)
 *
 * Create one client role assignment (AIP-133).
 */
export const resourceServerServiceCreateClientRoleAssignment = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceCreateClientRoleAssignmentData, ThrowOnError>): RequestResult<ResourceServerServiceCreateClientRoleAssignmentResponses, ResourceServerServiceCreateClientRoleAssignmentErrors, ThrowOnError> => (options.client ?? client).post<ResourceServerServiceCreateClientRoleAssignmentResponses, ResourceServerServiceCreateClientRoleAssignmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/clients/{client}/roleAssignments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete one client role assignment (AIP-135)
 *
 * Delete one client role assignment (AIP-135).
 */
export const resourceServerServiceDeleteClientRoleAssignment = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceDeleteClientRoleAssignmentData, ThrowOnError>): RequestResult<ResourceServerServiceDeleteClientRoleAssignmentResponses, ResourceServerServiceDeleteClientRoleAssignmentErrors, ThrowOnError> => (options.client ?? client).delete<ResourceServerServiceDeleteClientRoleAssignmentResponses, ResourceServerServiceDeleteClientRoleAssignmentErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/clients/{client}/roleAssignments/{roleAssignment}',
    ...options
});

/**
 * List introspection-client bindings of one resource server (AIP-132, AIP-158)
 *
 * List introspection-client bindings of one resource server (AIP-132, AIP-158).
 */
export const resourceServerServiceListIntrospectionClientBindings = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceListIntrospectionClientBindingsData, ThrowOnError>): RequestResult<ResourceServerServiceListIntrospectionClientBindingsResponses, ResourceServerServiceListIntrospectionClientBindingsErrors, ThrowOnError> => (options.client ?? client).get<ResourceServerServiceListIntrospectionClientBindingsResponses, ResourceServerServiceListIntrospectionClientBindingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/introspectionClients',
    ...options
});

/**
 * Create or replace one introspection-client trust binding; the pair is the
 *
 * Create or replace one introspection-client trust binding; the pair is the
 * identity, so the create is idempotent (AIP-133).
 */
export const resourceServerServiceCreateIntrospectionClientBinding = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceCreateIntrospectionClientBindingData, ThrowOnError>): RequestResult<ResourceServerServiceCreateIntrospectionClientBindingResponses, ResourceServerServiceCreateIntrospectionClientBindingErrors, ThrowOnError> => (options.client ?? client).post<ResourceServerServiceCreateIntrospectionClientBindingResponses, ResourceServerServiceCreateIntrospectionClientBindingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/introspectionClients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete one introspection-client trust binding (AIP-135)
 *
 * Delete one introspection-client trust binding (AIP-135).
 */
export const resourceServerServiceDeleteIntrospectionClientBinding = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceDeleteIntrospectionClientBindingData, ThrowOnError>): RequestResult<ResourceServerServiceDeleteIntrospectionClientBindingResponses, ResourceServerServiceDeleteIntrospectionClientBindingErrors, ThrowOnError> => (options.client ?? client).delete<ResourceServerServiceDeleteIntrospectionClientBindingResponses, ResourceServerServiceDeleteIntrospectionClientBindingErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/introspectionClients/{introspectionClient}',
    ...options
});

/**
 * List workload bindings of one resource server (AIP-132, AIP-158)
 *
 * List workload bindings of one resource server (AIP-132, AIP-158).
 */
export const resourceServerServiceListWorkloadBindings = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceListWorkloadBindingsData, ThrowOnError>): RequestResult<ResourceServerServiceListWorkloadBindingsResponses, ResourceServerServiceListWorkloadBindingsErrors, ThrowOnError> => (options.client ?? client).get<ResourceServerServiceListWorkloadBindingsResponses, ResourceServerServiceListWorkloadBindingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/workloads',
    ...options
});

/**
 * Create or replace one workload trust binding; the pair is the identity,
 *
 * Create or replace one workload trust binding; the pair is the identity,
 * so the create is idempotent (AIP-133).
 */
export const resourceServerServiceCreateWorkloadBinding = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceCreateWorkloadBindingData, ThrowOnError>): RequestResult<ResourceServerServiceCreateWorkloadBindingResponses, ResourceServerServiceCreateWorkloadBindingErrors, ThrowOnError> => (options.client ?? client).post<ResourceServerServiceCreateWorkloadBindingResponses, ResourceServerServiceCreateWorkloadBindingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/workloads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete one workload trust binding (AIP-135)
 *
 * Delete one workload trust binding (AIP-135).
 */
export const resourceServerServiceDeleteWorkloadBinding = <ThrowOnError extends boolean = false>(options: Options<ResourceServerServiceDeleteWorkloadBindingData, ThrowOnError>): RequestResult<ResourceServerServiceDeleteWorkloadBindingResponses, ResourceServerServiceDeleteWorkloadBindingErrors, ThrowOnError> => (options.client ?? client).delete<ResourceServerServiceDeleteWorkloadBindingResponses, ResourceServerServiceDeleteWorkloadBindingErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/resourceServers/{resourceServer}/workloads/{workload}',
    ...options
});

/**
 * Lists role definitions in a realm. Filter one identity's assignments with
 *
 * Lists role definitions in a realm. Filter one identity's assignments with
 * `identity = "<identity_id>"`; this is the endpoint for both the role
 * catalog page and a specific identity's roles, and internal policy callers
 * (Casbin, idaas-client) extract `display_name` to preserve their
 * string-only contract.
 */
export const accessControlServiceListRoles = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceListRolesData, ThrowOnError>): RequestResult<AccessControlServiceListRolesResponses, AccessControlServiceListRolesErrors, ThrowOnError> => (options.client ?? client).get<AccessControlServiceListRolesResponses, AccessControlServiceListRolesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/roles',
    ...options
});

/**
 * Creates a role
 *
 * Creates a role.
 */
export const accessControlServiceCreateRole = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceCreateRoleData, ThrowOnError>): RequestResult<AccessControlServiceCreateRoleResponses, AccessControlServiceCreateRoleErrors, ThrowOnError> => (options.client ?? client).post<AccessControlServiceCreateRoleResponses, AccessControlServiceCreateRoleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a role definition. Existing assignments become orphaned; callers
 *
 * Deletes a role definition. Existing assignments become orphaned; callers
 * should revoke outstanding assignments first if they care about that.
 */
export const accessControlServiceDeleteRole = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceDeleteRoleData, ThrowOnError>): RequestResult<AccessControlServiceDeleteRoleResponses, AccessControlServiceDeleteRoleErrors, ThrowOnError> => (options.client ?? client).delete<AccessControlServiceDeleteRoleResponses, AccessControlServiceDeleteRoleErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/roles/{role}',
    ...options
});

/**
 * Gets one role definition by resource name
 *
 * Gets one role definition by resource name.
 */
export const accessControlServiceGetRole = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceGetRoleData, ThrowOnError>): RequestResult<AccessControlServiceGetRoleResponses, AccessControlServiceGetRoleErrors, ThrowOnError> => (options.client ?? client).get<AccessControlServiceGetRoleResponses, AccessControlServiceGetRoleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/roles/{role}',
    ...options
});

/**
 * Updates a role definition. Only fields selected by `update_mask` are
 *
 * Updates a role definition. Only fields selected by `update_mask` are
 * applied; collection paths use replacement semantics, so a path included
 * with an empty collection explicitly clears that field.
 */
export const accessControlServiceUpdateRole = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceUpdateRoleData, ThrowOnError>): RequestResult<AccessControlServiceUpdateRoleResponses, AccessControlServiceUpdateRoleErrors, ThrowOnError> => (options.client ?? client).patch<AccessControlServiceUpdateRoleResponses, AccessControlServiceUpdateRoleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/roles/{role}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the identities currently assigned to a role inside a realm
 *
 * Lists the identities currently assigned to a role inside a realm.
 */
export const accessControlServiceListRoleMembers = <ThrowOnError extends boolean = false>(options: Options<AccessControlServiceListRoleMembersData, ThrowOnError>): RequestResult<AccessControlServiceListRoleMembersResponses, AccessControlServiceListRoleMembersErrors, ThrowOnError> => (options.client ?? client).get<AccessControlServiceListRoleMembersResponses, AccessControlServiceListRoleMembersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/roles/{role}/roleMembers',
    ...options
});

/**
 * Issue one signed assertion for a processed AuthnRequest context (AIP-136)
 *
 * Issue one signed assertion for a processed AuthnRequest context (AIP-136).
 */
export const samlIdpServiceGenerateAssertion = <ThrowOnError extends boolean = false>(options: Options<SamlIdpServiceGenerateAssertionData, ThrowOnError>): RequestResult<SamlIdpServiceGenerateAssertionResponses, SamlIdpServiceGenerateAssertionErrors, ThrowOnError> => (options.client ?? client).post<SamlIdpServiceGenerateAssertionResponses, SamlIdpServiceGenerateAssertionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/samlAssertionContexts:generateAssertion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Process one inbound AuthnRequest from a registered SP (AIP-136)
 *
 * Process one inbound AuthnRequest from a registered SP (AIP-136).
 */
export const samlIdpServiceProcessAuthnRequest = <ThrowOnError extends boolean = false>(options: Options<SamlIdpServiceProcessAuthnRequestData, ThrowOnError>): RequestResult<SamlIdpServiceProcessAuthnRequestResponses, SamlIdpServiceProcessAuthnRequestErrors, ThrowOnError> => (options.client ?? client).post<SamlIdpServiceProcessAuthnRequestResponses, SamlIdpServiceProcessAuthnRequestErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/realms/{realm}/samlAuthnRequests:processAuthnRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List SAML SP configurations of one realm (AIP-132, AIP-158)
 *
 * List SAML SP configurations of one realm (AIP-132, AIP-158).
 */
export const samlSpServiceListSamlConfigs = <ThrowOnError extends boolean = false>(options: Options<SamlSpServiceListSamlConfigsData, ThrowOnError>): RequestResult<SamlSpServiceListSamlConfigsResponses, SamlSpServiceListSamlConfigsErrors, ThrowOnError> => (options.client ?? client).get<SamlSpServiceListSamlConfigsResponses, SamlSpServiceListSamlConfigsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/samlConfigs',
    ...options
});

/**
 * Create one SAML SP configuration (AIP-133)
 *
 * Create one SAML SP configuration (AIP-133).
 */
export const samlSpServiceCreateSamlConfig = <ThrowOnError extends boolean = false>(options: Options<SamlSpServiceCreateSamlConfigData, ThrowOnError>): RequestResult<SamlSpServiceCreateSamlConfigResponses, SamlSpServiceCreateSamlConfigErrors, ThrowOnError> => (options.client ?? client).post<SamlSpServiceCreateSamlConfigResponses, SamlSpServiceCreateSamlConfigErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/samlConfigs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete one SAML SP configuration (AIP-135)
 *
 * Delete one SAML SP configuration (AIP-135).
 */
export const samlSpServiceDeleteSamlConfig = <ThrowOnError extends boolean = false>(options: Options<SamlSpServiceDeleteSamlConfigData, ThrowOnError>): RequestResult<SamlSpServiceDeleteSamlConfigResponses, SamlSpServiceDeleteSamlConfigErrors, ThrowOnError> => (options.client ?? client).delete<SamlSpServiceDeleteSamlConfigResponses, SamlSpServiceDeleteSamlConfigErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/samlConfigs/{samlConfig}',
    ...options
});

/**
 * Get one SAML SP configuration (AIP-131)
 *
 * Get one SAML SP configuration (AIP-131).
 */
export const samlSpServiceGetSamlConfig = <ThrowOnError extends boolean = false>(options: Options<SamlSpServiceGetSamlConfigData, ThrowOnError>): RequestResult<SamlSpServiceGetSamlConfigResponses, SamlSpServiceGetSamlConfigErrors, ThrowOnError> => (options.client ?? client).get<SamlSpServiceGetSamlConfigResponses, SamlSpServiceGetSamlConfigErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/samlConfigs/{samlConfig}',
    ...options
});

/**
 * Update one SAML SP configuration (AIP-134). The update fails when the
 *
 * Update one SAML SP configuration (AIP-134). The update fails when the
 * caller-observed revision is stale.
 */
export const samlSpServiceUpdateSamlConfig = <ThrowOnError extends boolean = false>(options: Options<SamlSpServiceUpdateSamlConfigData, ThrowOnError>): RequestResult<SamlSpServiceUpdateSamlConfigResponses, SamlSpServiceUpdateSamlConfigErrors, ThrowOnError> => (options.client ?? client).patch<SamlSpServiceUpdateSamlConfigResponses, SamlSpServiceUpdateSamlConfigErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/samlConfigs/{samlConfig}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render the SP SAML metadata document for one configuration (AIP-136)
 *
 * Render the SP SAML metadata document for one configuration (AIP-136).
 */
export const samlSpServiceRenderSamlMetadata = <ThrowOnError extends boolean = false>(options: Options<SamlSpServiceRenderSamlMetadataData, ThrowOnError>): RequestResult<SamlSpServiceRenderSamlMetadataResponses, SamlSpServiceRenderSamlMetadataErrors, ThrowOnError> => (options.client ?? client).get<SamlSpServiceRenderSamlMetadataResponses, SamlSpServiceRenderSamlMetadataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/realms/{realm}/samlConfigs/{samlConfig}/metadata:renderSamlMetadata',
    ...options
});

/**
 * Render the IdP SAML metadata document for one realm (AIP-136)
 *
 * Render the IdP SAML metadata document for one realm (AIP-136).
 */
export const samlIdpServiceRenderIdpMetadata = <ThrowOnError extends boolean = false>(options: Options<SamlIdpServiceRenderIdpMetadataData, ThrowOnError>): RequestResult<SamlIdpServiceRenderIdpMetadataResponses, SamlIdpServiceRenderIdpMetadataErrors, ThrowOnError> => (options.client ?? client).get<SamlIdpServiceRenderIdpMetadataResponses, SamlIdpServiceRenderIdpMetadataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/realms/{realm}/samlIdpMetadata:renderIdpMetadata',
    ...options
});

/**
 * Lists schema versions under a realm. Filter one family with
 *
 * Lists schema versions under a realm. Filter one family with
 * `family = "identity"`.
 */
export const schemaServiceListSchemas = <ThrowOnError extends boolean = false>(options: Options<SchemaServiceListSchemasData, ThrowOnError>): RequestResult<SchemaServiceListSchemasResponses, SchemaServiceListSchemasErrors, ThrowOnError> => (options.client ?? client).get<SchemaServiceListSchemasResponses, SchemaServiceListSchemasErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/schemas',
    ...options
});

/**
 * Creates a draft schema version under a realm. The definition must be a
 *
 * Creates a draft schema version under a realm. The definition must be a
 * valid JSON Schema document represented as a protobuf Struct.
 */
export const schemaServiceCreateSchema = <ThrowOnError extends boolean = false>(options: Options<SchemaServiceCreateSchemaData, ThrowOnError>): RequestResult<SchemaServiceCreateSchemaResponses, SchemaServiceCreateSchemaErrors, ThrowOnError> => (options.client ?? client).post<SchemaServiceCreateSchemaResponses, SchemaServiceCreateSchemaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/schemas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a schema version, returning the deleted aggregate. Deletion
 *
 * Deletes a schema version, returning the deleted aggregate. Deletion
 * fails while the version is active or identities still reference it.
 */
export const schemaServiceDeleteSchema = <ThrowOnError extends boolean = false>(options: Options<SchemaServiceDeleteSchemaData, ThrowOnError>): RequestResult<SchemaServiceDeleteSchemaResponses, SchemaServiceDeleteSchemaErrors, ThrowOnError> => (options.client ?? client).delete<SchemaServiceDeleteSchemaResponses, SchemaServiceDeleteSchemaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/schemas/{schema}',
    ...options
});

/**
 * Gets one schema version by stable resource name
 *
 * Gets one schema version by stable resource name.
 */
export const schemaServiceGetSchema = <ThrowOnError extends boolean = false>(options: Options<SchemaServiceGetSchemaData, ThrowOnError>): RequestResult<SchemaServiceGetSchemaResponses, SchemaServiceGetSchemaErrors, ThrowOnError> => (options.client ?? client).get<SchemaServiceGetSchemaResponses, SchemaServiceGetSchemaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/schemas/{schema}',
    ...options
});

/**
 * Activates a schema version by moving the owning realm's current pointer
 *
 * Activates a schema version by moving the owning realm's current pointer.
 */
export const schemaServiceActivateSchema = <ThrowOnError extends boolean = false>(options: Options<SchemaServiceActivateSchemaData, ThrowOnError>): RequestResult<SchemaServiceActivateSchemaResponses, SchemaServiceActivateSchemaErrors, ThrowOnError> => (options.client ?? client).post<SchemaServiceActivateSchemaResponses, SchemaServiceActivateSchemaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/schemas/{schema}:activate',
    ...options
});

/**
 * Describes how many identities still reference a schema version. Use this
 *
 * Describes how many identities still reference a schema version. Use this
 * before deletion to explain why a version cannot be removed.
 */
export const schemaServiceDescribeSchema = <ThrowOnError extends boolean = false>(options: Options<SchemaServiceDescribeSchemaData, ThrowOnError>): RequestResult<SchemaServiceDescribeSchemaResponses, SchemaServiceDescribeSchemaErrors, ThrowOnError> => (options.client ?? client).get<SchemaServiceDescribeSchemaResponses, SchemaServiceDescribeSchemaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/schemas/{schema}:describe',
    ...options
});

/**
 * Creates the next immutable draft version of a schema family from an
 *
 * Creates the next immutable draft version of a schema family from an
 * existing version. The family name carries over from the addressed
 * version; the new `version` must exceed the family's latest version.
 */
export const schemaServiceReviseSchema = <ThrowOnError extends boolean = false>(options: Options<SchemaServiceReviseSchemaData, ThrowOnError>): RequestResult<SchemaServiceReviseSchemaResponses, SchemaServiceReviseSchemaErrors, ThrowOnError> => (options.client ?? client).post<SchemaServiceReviseSchemaResponses, SchemaServiceReviseSchemaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/schemas/{schema}:revise',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolves the currently active version of a schema family under a realm
 *
 * Resolves the currently active version of a schema family under a realm.
 */
export const schemaServiceResolveActiveSchema = <ThrowOnError extends boolean = false>(options: Options<SchemaServiceResolveActiveSchemaData, ThrowOnError>): RequestResult<SchemaServiceResolveActiveSchemaResponses, SchemaServiceResolveActiveSchemaErrors, ThrowOnError> => (options.client ?? client).get<SchemaServiceResolveActiveSchemaResponses, SchemaServiceResolveActiveSchemaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/schemas:resolve',
    ...options
});

/**
 * List registered service providers of one realm (AIP-132, AIP-158)
 *
 * List registered service providers of one realm (AIP-132, AIP-158).
 */
export const samlIdpServiceListServiceProviders = <ThrowOnError extends boolean = false>(options: Options<SamlIdpServiceListServiceProvidersData, ThrowOnError>): RequestResult<SamlIdpServiceListServiceProvidersResponses, SamlIdpServiceListServiceProvidersErrors, ThrowOnError> => (options.client ?? client).get<SamlIdpServiceListServiceProvidersResponses, SamlIdpServiceListServiceProvidersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/serviceProviders',
    ...options
});

/**
 * Create one registered service provider (AIP-133)
 *
 * Create one registered service provider (AIP-133).
 */
export const samlIdpServiceCreateServiceProvider = <ThrowOnError extends boolean = false>(options: Options<SamlIdpServiceCreateServiceProviderData, ThrowOnError>): RequestResult<SamlIdpServiceCreateServiceProviderResponses, SamlIdpServiceCreateServiceProviderErrors, ThrowOnError> => (options.client ?? client).post<SamlIdpServiceCreateServiceProviderResponses, SamlIdpServiceCreateServiceProviderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/serviceProviders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete one registered service provider (AIP-135)
 *
 * Delete one registered service provider (AIP-135).
 */
export const samlIdpServiceDeleteServiceProvider = <ThrowOnError extends boolean = false>(options: Options<SamlIdpServiceDeleteServiceProviderData, ThrowOnError>): RequestResult<SamlIdpServiceDeleteServiceProviderResponses, SamlIdpServiceDeleteServiceProviderErrors, ThrowOnError> => (options.client ?? client).delete<SamlIdpServiceDeleteServiceProviderResponses, SamlIdpServiceDeleteServiceProviderErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/serviceProviders/{serviceProvider}',
    ...options
});

/**
 * Get one registered service provider (AIP-131)
 *
 * Get one registered service provider (AIP-131).
 */
export const samlIdpServiceGetServiceProvider = <ThrowOnError extends boolean = false>(options: Options<SamlIdpServiceGetServiceProviderData, ThrowOnError>): RequestResult<SamlIdpServiceGetServiceProviderResponses, SamlIdpServiceGetServiceProviderErrors, ThrowOnError> => (options.client ?? client).get<SamlIdpServiceGetServiceProviderResponses, SamlIdpServiceGetServiceProviderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/serviceProviders/{serviceProvider}',
    ...options
});

/**
 * Update one registered service provider (AIP-134)
 *
 * Update one registered service provider (AIP-134).
 */
export const samlIdpServiceUpdateServiceProvider = <ThrowOnError extends boolean = false>(options: Options<SamlIdpServiceUpdateServiceProviderData, ThrowOnError>): RequestResult<SamlIdpServiceUpdateServiceProviderResponses, SamlIdpServiceUpdateServiceProviderErrors, ThrowOnError> => (options.client ?? client).patch<SamlIdpServiceUpdateServiceProviderResponses, SamlIdpServiceUpdateServiceProviderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/serviceProviders/{serviceProvider}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Look one registered service provider up by its SP entity id (AIP-136)
 *
 * Look one registered service provider up by its SP entity id (AIP-136).
 */
export const samlIdpServiceResolveServiceProvider = <ThrowOnError extends boolean = false>(options: Options<SamlIdpServiceResolveServiceProviderData, ThrowOnError>): RequestResult<SamlIdpServiceResolveServiceProviderResponses, SamlIdpServiceResolveServiceProviderErrors, ThrowOnError> => (options.client ?? client).get<SamlIdpServiceResolveServiceProviderResponses, SamlIdpServiceResolveServiceProviderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/serviceProviders:resolve',
    ...options
});

/**
 * List social providers of one realm (AIP-132, AIP-158)
 *
 * List social providers of one realm (AIP-132, AIP-158).
 */
export const socialProviderServiceListSocialProviders = <ThrowOnError extends boolean = false>(options: Options<SocialProviderServiceListSocialProvidersData, ThrowOnError>): RequestResult<SocialProviderServiceListSocialProvidersResponses, SocialProviderServiceListSocialProvidersErrors, ThrowOnError> => (options.client ?? client).get<SocialProviderServiceListSocialProvidersResponses, SocialProviderServiceListSocialProvidersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/socialProviders',
    ...options
});

/**
 * Create one social provider (AIP-133)
 *
 * Create one social provider (AIP-133).
 */
export const socialProviderServiceCreateSocialProvider = <ThrowOnError extends boolean = false>(options: Options<SocialProviderServiceCreateSocialProviderData, ThrowOnError>): RequestResult<SocialProviderServiceCreateSocialProviderResponses, SocialProviderServiceCreateSocialProviderErrors, ThrowOnError> => (options.client ?? client).post<SocialProviderServiceCreateSocialProviderResponses, SocialProviderServiceCreateSocialProviderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/socialProviders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete one social provider (AIP-135)
 *
 * Delete one social provider (AIP-135).
 */
export const socialProviderServiceDeleteSocialProvider = <ThrowOnError extends boolean = false>(options: Options<SocialProviderServiceDeleteSocialProviderData, ThrowOnError>): RequestResult<SocialProviderServiceDeleteSocialProviderResponses, SocialProviderServiceDeleteSocialProviderErrors, ThrowOnError> => (options.client ?? client).delete<SocialProviderServiceDeleteSocialProviderResponses, SocialProviderServiceDeleteSocialProviderErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/socialProviders/{socialProvider}',
    ...options
});

/**
 * Get one social provider (AIP-131)
 *
 * Get one social provider (AIP-131).
 */
export const socialProviderServiceGetSocialProvider = <ThrowOnError extends boolean = false>(options: Options<SocialProviderServiceGetSocialProviderData, ThrowOnError>): RequestResult<SocialProviderServiceGetSocialProviderResponses, SocialProviderServiceGetSocialProviderErrors, ThrowOnError> => (options.client ?? client).get<SocialProviderServiceGetSocialProviderResponses, SocialProviderServiceGetSocialProviderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/socialProviders/{socialProvider}',
    ...options
});

/**
 * Update one social provider (AIP-134)
 *
 * Update one social provider (AIP-134).
 */
export const socialProviderServiceUpdateSocialProvider = <ThrowOnError extends boolean = false>(options: Options<SocialProviderServiceUpdateSocialProviderData, ThrowOnError>): RequestResult<SocialProviderServiceUpdateSocialProviderResponses, SocialProviderServiceUpdateSocialProviderErrors, ThrowOnError> => (options.client ?? client).patch<SocialProviderServiceUpdateSocialProviderResponses, SocialProviderServiceUpdateSocialProviderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/socialProviders/{socialProvider}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace the provider client secret (AIP-136)
 *
 * Replace the provider client secret (AIP-136).
 */
export const socialProviderServiceRotateSocialProviderSecret = <ThrowOnError extends boolean = false>(options: Options<SocialProviderServiceRotateSocialProviderSecretData, ThrowOnError>): RequestResult<SocialProviderServiceRotateSocialProviderSecretResponses, SocialProviderServiceRotateSocialProviderSecretErrors, ThrowOnError> => (options.client ?? client).post<SocialProviderServiceRotateSocialProviderSecretResponses, SocialProviderServiceRotateSocialProviderSecretErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/socialProviders/{socialProvider}/clientSecret:rotateSocialProviderSecret',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke retained profile snapshots of one provider (AIP-136)
 *
 * Revoke retained profile snapshots of one provider (AIP-136).
 */
export const socialProviderServiceRevokeRetainedSnapshots = <ThrowOnError extends boolean = false>(options: Options<SocialProviderServiceRevokeRetainedSnapshotsData, ThrowOnError>): RequestResult<SocialProviderServiceRevokeRetainedSnapshotsResponses, SocialProviderServiceRevokeRetainedSnapshotsErrors, ThrowOnError> => (options.client ?? client).post<SocialProviderServiceRevokeRetainedSnapshotsResponses, SocialProviderServiceRevokeRetainedSnapshotsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/socialProviders/{socialProvider}/retainedSnapshots:revokeRetainedSnapshots',
    ...options
});

/**
 * Revoke retained upstream access/refresh tokens of one provider (AIP-136)
 *
 * Revoke retained upstream access/refresh tokens of one provider (AIP-136).
 */
export const socialProviderServiceRevokeRetainedTokens = <ThrowOnError extends boolean = false>(options: Options<SocialProviderServiceRevokeRetainedTokensData, ThrowOnError>): RequestResult<SocialProviderServiceRevokeRetainedTokensResponses, SocialProviderServiceRevokeRetainedTokensErrors, ThrowOnError> => (options.client ?? client).post<SocialProviderServiceRevokeRetainedTokensResponses, SocialProviderServiceRevokeRetainedTokensErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/socialProviders/{socialProvider}/retainedTokens:revokeRetainedTokens',
    ...options
});

/**
 * Probe the provider endpoint set with the stored client credentials
 *
 * Probe the provider endpoint set with the stored client credentials
 * (AIP-136).
 */
export const socialProviderServiceTestSocialProvider = <ThrowOnError extends boolean = false>(options: Options<SocialProviderServiceTestSocialProviderData, ThrowOnError>): RequestResult<SocialProviderServiceTestSocialProviderResponses, SocialProviderServiceTestSocialProviderErrors, ThrowOnError> => (options.client ?? client).post<SocialProviderServiceTestSocialProviderResponses, SocialProviderServiceTestSocialProviderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/socialProviders/{socialProvider}:test',
    ...options
});

/**
 * List webhooks of one realm (AIP-132, AIP-158)
 *
 * List webhooks of one realm (AIP-132, AIP-158).
 */
export const webhookServiceListWebhooks = <ThrowOnError extends boolean = false>(options: Options<WebhookServiceListWebhooksData, ThrowOnError>): RequestResult<WebhookServiceListWebhooksResponses, WebhookServiceListWebhooksErrors, ThrowOnError> => (options.client ?? client).get<WebhookServiceListWebhooksResponses, WebhookServiceListWebhooksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/webhooks',
    ...options
});

/**
 * Create one webhook (AIP-133)
 *
 * Create one webhook (AIP-133).
 */
export const webhookServiceCreateWebhook = <ThrowOnError extends boolean = false>(options: Options<WebhookServiceCreateWebhookData, ThrowOnError>): RequestResult<WebhookServiceCreateWebhookResponses, WebhookServiceCreateWebhookErrors, ThrowOnError> => (options.client ?? client).post<WebhookServiceCreateWebhookResponses, WebhookServiceCreateWebhookErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/webhooks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete one webhook (AIP-135)
 *
 * Delete one webhook (AIP-135).
 */
export const webhookServiceDeleteWebhook = <ThrowOnError extends boolean = false>(options: Options<WebhookServiceDeleteWebhookData, ThrowOnError>): RequestResult<WebhookServiceDeleteWebhookResponses, WebhookServiceDeleteWebhookErrors, ThrowOnError> => (options.client ?? client).delete<WebhookServiceDeleteWebhookResponses, WebhookServiceDeleteWebhookErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/webhooks/{webhook}',
    ...options
});

/**
 * Get one webhook (AIP-131)
 *
 * Get one webhook (AIP-131).
 */
export const webhookServiceGetWebhook = <ThrowOnError extends boolean = false>(options: Options<WebhookServiceGetWebhookData, ThrowOnError>): RequestResult<WebhookServiceGetWebhookResponses, WebhookServiceGetWebhookErrors, ThrowOnError> => (options.client ?? client).get<WebhookServiceGetWebhookResponses, WebhookServiceGetWebhookErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/webhooks/{webhook}',
    ...options
});

/**
 * Update one webhook (AIP-134)
 *
 * Update one webhook (AIP-134).
 */
export const webhookServiceUpdateWebhook = <ThrowOnError extends boolean = false>(options: Options<WebhookServiceUpdateWebhookData, ThrowOnError>): RequestResult<WebhookServiceUpdateWebhookResponses, WebhookServiceUpdateWebhookErrors, ThrowOnError> => (options.client ?? client).patch<WebhookServiceUpdateWebhookResponses, WebhookServiceUpdateWebhookErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/webhooks/{webhook}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deliver one signed test payload to the configured endpoint (AIP-136)
 *
 * Deliver one signed test payload to the configured endpoint (AIP-136).
 */
export const webhookServiceTestWebhook = <ThrowOnError extends boolean = false>(options: Options<WebhookServiceTestWebhookData, ThrowOnError>): RequestResult<WebhookServiceTestWebhookResponses, WebhookServiceTestWebhookErrors, ThrowOnError> => (options.client ?? client).post<WebhookServiceTestWebhookResponses, WebhookServiceTestWebhookErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/webhooks/{webhook}:test',
    ...options
});

/**
 * Lists allow-list entries under a realm
 *
 * Lists allow-list entries under a realm.
 */
export const rateLimitServiceListWhitelistEntries = <ThrowOnError extends boolean = false>(options: Options<RateLimitServiceListWhitelistEntriesData, ThrowOnError>): RequestResult<RateLimitServiceListWhitelistEntriesResponses, RateLimitServiceListWhitelistEntriesErrors, ThrowOnError> => (options.client ?? client).get<RateLimitServiceListWhitelistEntriesResponses, RateLimitServiceListWhitelistEntriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/whitelistEntries',
    ...options
});

/**
 * Adds an IP or CIDR range to the realm allow list
 *
 * Adds an IP or CIDR range to the realm allow list.
 */
export const rateLimitServiceCreateWhitelistEntry = <ThrowOnError extends boolean = false>(options: Options<RateLimitServiceCreateWhitelistEntryData, ThrowOnError>): RequestResult<RateLimitServiceCreateWhitelistEntryResponses, RateLimitServiceCreateWhitelistEntryErrors, ThrowOnError> => (options.client ?? client).post<RateLimitServiceCreateWhitelistEntryResponses, RateLimitServiceCreateWhitelistEntryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/whitelistEntries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes an entry from the realm allow list
 *
 * Removes an entry from the realm allow list.
 */
export const rateLimitServiceDeleteWhitelistEntry = <ThrowOnError extends boolean = false>(options: Options<RateLimitServiceDeleteWhitelistEntryData, ThrowOnError>): RequestResult<RateLimitServiceDeleteWhitelistEntryResponses, RateLimitServiceDeleteWhitelistEntryErrors, ThrowOnError> => (options.client ?? client).delete<RateLimitServiceDeleteWhitelistEntryResponses, RateLimitServiceDeleteWhitelistEntryErrors, ThrowOnError>({
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/whitelistEntries/{whitelistEntry}',
    ...options
});

/**
 * Gets one allow-list entry by resource name
 *
 * Gets one allow-list entry by resource name.
 */
export const rateLimitServiceGetWhitelistEntry = <ThrowOnError extends boolean = false>(options: Options<RateLimitServiceGetWhitelistEntryData, ThrowOnError>): RequestResult<RateLimitServiceGetWhitelistEntryResponses, RateLimitServiceGetWhitelistEntryErrors, ThrowOnError> => (options.client ?? client).get<RateLimitServiceGetWhitelistEntryResponses, RateLimitServiceGetWhitelistEntryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/realms/{realm}/whitelistEntries/{whitelistEntry}',
    ...options
});

/**
 * Resets the password after a recovery flow has been verified
 *
 * Resets the password after a recovery flow has been verified.
 */
export const recoveryFlowServiceResetPassword = <ThrowOnError extends boolean = false>(options: Options<RecoveryFlowServiceResetPasswordData, ThrowOnError>): RequestResult<RecoveryFlowServiceResetPasswordResponses, RecoveryFlowServiceResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<RecoveryFlowServiceResetPasswordResponses, RecoveryFlowServiceResetPasswordErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/recovery/flows/{flow}:resetPassword',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verifies the recovery code and marks the flow as ready for password reset
 *
 * Verifies the recovery code and marks the flow as ready for password reset.
 */
export const recoveryFlowServiceSubmitRecoveryFlow = <ThrowOnError extends boolean = false>(options: Options<RecoveryFlowServiceSubmitRecoveryFlowData, ThrowOnError>): RequestResult<RecoveryFlowServiceSubmitRecoveryFlowResponses, RecoveryFlowServiceSubmitRecoveryFlowErrors, ThrowOnError> => (options.client ?? client).post<RecoveryFlowServiceSubmitRecoveryFlowResponses, RecoveryFlowServiceSubmitRecoveryFlowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/recovery/flows/{flow}:submitRecoveryFlow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Initialize a new recovery flow (send recovery code email)
 *
 * Initialize a new recovery flow (send recovery code email)
 */
export const recoveryFlowServiceInitRecoveryFlow = <ThrowOnError extends boolean = false>(options: Options<RecoveryFlowServiceInitRecoveryFlowData, ThrowOnError>): RequestResult<RecoveryFlowServiceInitRecoveryFlowResponses, RecoveryFlowServiceInitRecoveryFlowErrors, ThrowOnError> => (options.client ?? client).post<RecoveryFlowServiceInitRecoveryFlowResponses, RecoveryFlowServiceInitRecoveryFlowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/recovery/flows:initRecoveryFlow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submits a registration flow and creates the identity plus credentials when
 *
 * Submits a registration flow and creates the identity plus credentials when
 * all realm policies are satisfied.
 */
export const registerFlowServiceSubmitRegister = <ThrowOnError extends boolean = false>(options: Options<RegisterFlowServiceSubmitRegisterData, ThrowOnError>): RequestResult<RegisterFlowServiceSubmitRegisterResponses, RegisterFlowServiceSubmitRegisterErrors, ThrowOnError> => (options.client ?? client).post<RegisterFlowServiceSubmitRegisterResponses, RegisterFlowServiceSubmitRegisterErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/register/flows/{flow}:submitRegister',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates a short-lived registration flow for a realm
 *
 * Creates a short-lived registration flow for a realm.
 */
export const registerFlowServiceInitRegisterFlow = <ThrowOnError extends boolean = false>(options: Options<RegisterFlowServiceInitRegisterFlowData, ThrowOnError>): RequestResult<RegisterFlowServiceInitRegisterFlowResponses, RegisterFlowServiceInitRegisterFlowErrors, ThrowOnError> => (options.client ?? client).post<RegisterFlowServiceInitRegisterFlowResponses, RegisterFlowServiceInitRegisterFlowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/register/flows:initRegisterFlow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refreshes a session's expiry according to realm session policy
 *
 * Refreshes a session's expiry according to realm session policy.
 */
export const sessionServiceRefreshSession = <ThrowOnError extends boolean = false>(options: Options<SessionServiceRefreshSessionData, ThrowOnError>): RequestResult<SessionServiceRefreshSessionResponses, SessionServiceRefreshSessionErrors, ThrowOnError> => (options.client ?? client).post<SessionServiceRefreshSessionResponses, SessionServiceRefreshSessionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/sessions/{session}:refreshSession',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revokes one session by its server-side session ID within a realm
 *
 * Revokes one session by its server-side session ID within a realm.
 *
 * This operation is intended for administrative and account-management
 * surfaces that list sessions by ID. Browser logout flows should call
 * LogoutSession with the session token instead, because a caller may not know
 * the current session ID before validating its token.
 */
export const sessionServiceRevokeSession = <ThrowOnError extends boolean = false>(options: Options<SessionServiceRevokeSessionData, ThrowOnError>): RequestResult<SessionServiceRevokeSessionResponses, SessionServiceRevokeSessionErrors, ThrowOnError> => (options.client ?? client).post<SessionServiceRevokeSessionResponses, SessionServiceRevokeSessionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/sessions/{session}:revokeSession',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revokes the session represented by the supplied token
 *
 * Revokes the session represented by the supplied token.
 */
export const sessionServiceLogoutSession = <ThrowOnError extends boolean = false>(options: Options<SessionServiceLogoutSessionData, ThrowOnError>): RequestResult<SessionServiceLogoutSessionResponses, SessionServiceLogoutSessionErrors, ThrowOnError> => (options.client ?? client).post<SessionServiceLogoutSessionResponses, SessionServiceLogoutSessionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/sessions:logoutSession',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validates a session token and returns the authenticated identity summary
 *
 * Validates a session token and returns the authenticated identity summary.
 * This is equivalent to a "whoami" call and is used by the gateway before
 * issuing OAuth authorization codes.
 */
export const sessionServiceValidateSession = <ThrowOnError extends boolean = false>(options: Options<SessionServiceValidateSessionData, ThrowOnError>): RequestResult<SessionServiceValidateSessionResponses, SessionServiceValidateSessionErrors, ThrowOnError> => (options.client ?? client).post<SessionServiceValidateSessionResponses, SessionServiceValidateSessionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/sessions:validateSession',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists tenants
 *
 * Lists tenants.
 */
export const tenantServiceListTenants = <ThrowOnError extends boolean = false>(options?: Options<TenantServiceListTenantsData, ThrowOnError>): RequestResult<TenantServiceListTenantsResponses, TenantServiceListTenantsErrors, ThrowOnError> => (options?.client ?? client).get<TenantServiceListTenantsResponses, TenantServiceListTenantsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants',
    ...options
});

/**
 * Creates a tenant without creating any realm or administrator identity
 *
 * Creates a tenant without creating any realm or administrator identity.
 */
export const tenantServiceCreateTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceCreateTenantData, ThrowOnError>): RequestResult<TenantServiceCreateTenantResponses, TenantServiceCreateTenantErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceCreateTenantResponses, TenantServiceCreateTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a tenant, returning the deleted aggregate
 *
 * Deletes a tenant, returning the deleted aggregate.
 */
export const tenantServiceDeleteTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceDeleteTenantData, ThrowOnError>): RequestResult<TenantServiceDeleteTenantResponses, TenantServiceDeleteTenantErrors, ThrowOnError> => (options.client ?? client).delete<TenantServiceDeleteTenantResponses, TenantServiceDeleteTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}',
    ...options
});

/**
 * Gets a tenant
 *
 * Gets a tenant.
 */
export const tenantServiceGetTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceGetTenantData, ThrowOnError>): RequestResult<TenantServiceGetTenantResponses, TenantServiceGetTenantErrors, ThrowOnError> => (options.client ?? client).get<TenantServiceGetTenantResponses, TenantServiceGetTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}',
    ...options
});

/**
 * Updates a tenant's mutable fields
 *
 * Updates a tenant's mutable fields.
 */
export const tenantServiceUpdateTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceUpdateTenantData, ThrowOnError>): RequestResult<TenantServiceUpdateTenantResponses, TenantServiceUpdateTenantErrors, ThrowOnError> => (options.client ?? client).patch<TenantServiceUpdateTenantResponses, TenantServiceUpdateTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists realms under a tenant. The parent `tenants/-` (AIP-159) lists
 *
 * Lists realms under a tenant. The parent `tenants/-` (AIP-159) lists
 * realms across all tenants and requires platform scope.
 */
export const realmServiceListRealms = <ThrowOnError extends boolean = false>(options: Options<RealmServiceListRealmsData, ThrowOnError>): RequestResult<RealmServiceListRealmsResponses, RealmServiceListRealmsErrors, ThrowOnError> => (options.client ?? client).get<RealmServiceListRealmsResponses, RealmServiceListRealmsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}/realms',
    ...options
});

/**
 * Creates a realm under a tenant. Realm names should be unique within a
 *
 * Creates a realm under a tenant. Realm names should be unique within a
 * tenant and safe for display; the stable identifier is realm_id.
 */
export const realmServiceCreateRealm = <ThrowOnError extends boolean = false>(options: Options<RealmServiceCreateRealmData, ThrowOnError>): RequestResult<RealmServiceCreateRealmResponses, RealmServiceCreateRealmErrors, ThrowOnError> => (options.client ?? client).post<RealmServiceCreateRealmResponses, RealmServiceCreateRealmErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}/realms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a realm, returning the deleted aggregate
 *
 * Deletes a realm, returning the deleted aggregate.
 */
export const realmServiceDeleteRealm = <ThrowOnError extends boolean = false>(options: Options<RealmServiceDeleteRealmData, ThrowOnError>): RequestResult<RealmServiceDeleteRealmResponses, RealmServiceDeleteRealmErrors, ThrowOnError> => (options.client ?? client).delete<RealmServiceDeleteRealmResponses, RealmServiceDeleteRealmErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}/realms/{realm}',
    ...options
});

/**
 * Gets a realm
 *
 * Gets a realm.
 */
export const realmServiceGetRealm = <ThrowOnError extends boolean = false>(options: Options<RealmServiceGetRealmData, ThrowOnError>): RequestResult<RealmServiceGetRealmResponses, RealmServiceGetRealmErrors, ThrowOnError> => (options.client ?? client).get<RealmServiceGetRealmResponses, RealmServiceGetRealmErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}/realms/{realm}',
    ...options
});

/**
 * Updates a realm's mutable fields
 *
 * Updates a realm's mutable fields.
 */
export const realmServiceUpdateRealm = <ThrowOnError extends boolean = false>(options: Options<RealmServiceUpdateRealmData, ThrowOnError>): RequestResult<RealmServiceUpdateRealmResponses, RealmServiceUpdateRealmErrors, ThrowOnError> => (options.client ?? client).patch<RealmServiceUpdateRealmResponses, RealmServiceUpdateRealmErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}/realms/{realm}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reactivates a suspended realm. Restoring an archived realm additionally
 *
 * Reactivates a suspended realm. Restoring an archived realm additionally
 * requires platform scope.
 */
export const realmServiceActivateRealm = <ThrowOnError extends boolean = false>(options: Options<RealmServiceActivateRealmData, ThrowOnError>): RequestResult<RealmServiceActivateRealmResponses, RealmServiceActivateRealmErrors, ThrowOnError> => (options.client ?? client).post<RealmServiceActivateRealmResponses, RealmServiceActivateRealmErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}/realms/{realm}:activate',
    ...options
});

/**
 * Archives a suspended realm
 *
 * Archives a suspended realm.
 */
export const realmServiceArchiveRealm = <ThrowOnError extends boolean = false>(options: Options<RealmServiceArchiveRealmData, ThrowOnError>): RequestResult<RealmServiceArchiveRealmResponses, RealmServiceArchiveRealmErrors, ThrowOnError> => (options.client ?? client).post<RealmServiceArchiveRealmResponses, RealmServiceArchiveRealmErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}/realms/{realm}:archive',
    ...options
});

/**
 * Suspends an active realm
 *
 * Suspends an active realm.
 */
export const realmServiceSuspendRealm = <ThrowOnError extends boolean = false>(options: Options<RealmServiceSuspendRealmData, ThrowOnError>): RequestResult<RealmServiceSuspendRealmResponses, RealmServiceSuspendRealmErrors, ThrowOnError> => (options.client ?? client).post<RealmServiceSuspendRealmResponses, RealmServiceSuspendRealmErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}/realms/{realm}:suspend',
    ...options
});

/**
 * Reactivates a suspended tenant
 *
 * Reactivates a suspended tenant.
 */
export const tenantServiceActivateTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceActivateTenantData, ThrowOnError>): RequestResult<TenantServiceActivateTenantResponses, TenantServiceActivateTenantErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceActivateTenantResponses, TenantServiceActivateTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}:activate',
    ...options
});

/**
 * Archives a suspended tenant
 *
 * Archives a suspended tenant.
 */
export const tenantServiceArchiveTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceArchiveTenantData, ThrowOnError>): RequestResult<TenantServiceArchiveTenantResponses, TenantServiceArchiveTenantErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceArchiveTenantResponses, TenantServiceArchiveTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}:archive',
    ...options
});

/**
 * Returns aggregate realm and identity usage for a tenant. This endpoint is
 *
 * Returns aggregate realm and identity usage for a tenant. This endpoint is
 * intended for platform admin dashboards and quota enforcement views.
 */
export const tenantServiceComputeTenantStats = <ThrowOnError extends boolean = false>(options: Options<TenantServiceComputeTenantStatsData, ThrowOnError>): RequestResult<TenantServiceComputeTenantStatsResponses, TenantServiceComputeTenantStatsErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceComputeTenantStatsResponses, TenantServiceComputeTenantStatsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}:computeTenantStats',
    ...options
});

/**
 * Suspends an active tenant
 *
 * Suspends an active tenant.
 */
export const tenantServiceSuspendTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceSuspendTenantData, ThrowOnError>): RequestResult<TenantServiceSuspendTenantResponses, TenantServiceSuspendTenantErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceSuspendTenantResponses, TenantServiceSuspendTenantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/idaas/tenants/{tenant}:suspend',
    ...options
});

/**
 * Self-service tenant registration. This creates a tenant, default realm, and
 *
 * Self-service tenant registration. This creates a tenant, default realm, and
 * initial administrator identity in one audited operation.
 */
export const tenantServiceRegisterTenant = <ThrowOnError extends boolean = false>(options: Options<TenantServiceRegisterTenantData, ThrowOnError>): RequestResult<TenantServiceRegisterTenantResponses, TenantServiceRegisterTenantErrors, ThrowOnError> => (options.client ?? client).post<TenantServiceRegisterTenantResponses, TenantServiceRegisterTenantErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idaas/tenants:registerTenant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * OpenID Provider metadata
 */
export const oidcProtocolGetDiscovery = <ThrowOnError extends boolean = false>(options?: Options<OidcProtocolGetDiscoveryData, ThrowOnError>): RequestResult<OidcProtocolGetDiscoveryResponses, OidcProtocolGetDiscoveryErrors, ThrowOnError> => (options?.client ?? client).get<OidcProtocolGetDiscoveryResponses, OidcProtocolGetDiscoveryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/.well-known/openid-configuration',
    ...options
});

/**
 * JSON Web Key Set
 */
export const oidcProtocolGetJwks = <ThrowOnError extends boolean = false>(options?: Options<OidcProtocolGetJwksData, ThrowOnError>): RequestResult<OidcProtocolGetJwksResponses, OidcProtocolGetJwksErrors, ThrowOnError> => (options?.client ?? client).get<OidcProtocolGetJwksResponses, OidcProtocolGetJwksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/.well-known/jwks.json',
    ...options
});

/**
 * Start or resume authorization
 */
export const oidcProtocolAuthorizeGet = <ThrowOnError extends boolean = false>(options?: Options<OidcProtocolAuthorizeGetData, ThrowOnError>): RequestResult<OidcProtocolAuthorizeGetResponses, OidcProtocolAuthorizeGetErrors, ThrowOnError> => (options?.client ?? client).get<OidcProtocolAuthorizeGetResponses, OidcProtocolAuthorizeGetErrors, ThrowOnError>({
    responseType: 'text',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/oauth2/authorize',
    ...options
});

/**
 * Start or resume authorization using form serialization
 */
export const oidcProtocolAuthorizePost = <ThrowOnError extends boolean = false>(options: Options<OidcProtocolAuthorizePostData, ThrowOnError>): RequestResult<OidcProtocolAuthorizePostResponses, OidcProtocolAuthorizePostErrors, ThrowOnError> => (options.client ?? client).post<OidcProtocolAuthorizePostResponses, OidcProtocolAuthorizePostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'text',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/oauth2/authorize',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Exchange an authorization grant for tokens
 */
export const oidcProtocolExchangeToken = <ThrowOnError extends boolean = false>(options: Options<OidcProtocolExchangeTokenData, ThrowOnError>): RequestResult<OidcProtocolExchangeTokenResponses, OidcProtocolExchangeTokenErrors, ThrowOnError> => (options.client ?? client).post<OidcProtocolExchangeTokenResponses, OidcProtocolExchangeTokenErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'basic', type: 'http' }],
    url: '/oauth2/token',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Introspect a token
 */
export const oidcProtocolIntrospect = <ThrowOnError extends boolean = false>(options: Options<OidcProtocolIntrospectData, ThrowOnError>): RequestResult<OidcProtocolIntrospectResponses, OidcProtocolIntrospectErrors, ThrowOnError> => (options.client ?? client).post<OidcProtocolIntrospectResponses, OidcProtocolIntrospectErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'basic', type: 'http' }],
    url: '/oauth2/introspect',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Revoke a refresh token
 */
export const oidcProtocolRevoke = <ThrowOnError extends boolean = false>(options: Options<OidcProtocolRevokeData, ThrowOnError>): RequestResult<OidcProtocolRevokeResponses, OidcProtocolRevokeErrors, ThrowOnError> => (options.client ?? client).post<OidcProtocolRevokeResponses, OidcProtocolRevokeErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    security: [{ scheme: 'basic', type: 'http' }],
    url: '/oauth2/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Return claims for an access token
 */
export const oidcProtocolUserInfoGet = <ThrowOnError extends boolean = false>(options?: Options<OidcProtocolUserInfoGetData, ThrowOnError>): RequestResult<OidcProtocolUserInfoGetResponses, OidcProtocolUserInfoGetErrors, ThrowOnError> => (options?.client ?? client).get<OidcProtocolUserInfoGetResponses, OidcProtocolUserInfoGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'oauthBearer',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/oauth2/userinfo',
    ...options
});

/**
 * Return claims for an access token
 */
export const oidcProtocolUserInfoPost = <ThrowOnError extends boolean = false>(options?: Options<OidcProtocolUserInfoPostData, ThrowOnError>): RequestResult<OidcProtocolUserInfoPostResponses, OidcProtocolUserInfoPostErrors, ThrowOnError> => (options?.client ?? client).post<OidcProtocolUserInfoPostResponses, OidcProtocolUserInfoPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            key: 'oauthBearer',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/oauth2/userinfo',
    ...options
});

/**
 * Start a Device Authorization Grant
 */
export const oidcProtocolAuthorizeDevice = <ThrowOnError extends boolean = false>(options: Options<OidcProtocolAuthorizeDeviceData, ThrowOnError>): RequestResult<OidcProtocolAuthorizeDeviceResponses, OidcProtocolAuthorizeDeviceErrors, ThrowOnError> => (options.client ?? client).post<OidcProtocolAuthorizeDeviceResponses, OidcProtocolAuthorizeDeviceErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'basic', type: 'http' }],
    url: '/oauth2/device_authorization',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Enter a device user code or render approval
 */
export const oidcProtocolDeviceVerificationGet = <ThrowOnError extends boolean = false>(options?: Options<OidcProtocolDeviceVerificationGetData, ThrowOnError>): RequestResult<OidcProtocolDeviceVerificationGetResponses, OidcProtocolDeviceVerificationGetErrors, ThrowOnError> => (options?.client ?? client).get<OidcProtocolDeviceVerificationGetResponses, OidcProtocolDeviceVerificationGetErrors, ThrowOnError>({
    responseType: 'text',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/oauth2/device/verify',
    ...options
});

/**
 * Submit a device code or authenticated approval decision
 */
export const oidcProtocolDeviceVerificationPost = <ThrowOnError extends boolean = false>(options: Options<OidcProtocolDeviceVerificationPostData, ThrowOnError>): RequestResult<OidcProtocolDeviceVerificationPostResponses, OidcProtocolDeviceVerificationPostErrors, ThrowOnError> => (options.client ?? client).post<OidcProtocolDeviceVerificationPostResponses, OidcProtocolDeviceVerificationPostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'text',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/oauth2/device/verify',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Validate logout context or render current-session confirmation
 */
export const oidcProtocolEndSessionGet = <ThrowOnError extends boolean = false>(options?: Options<OidcProtocolEndSessionGetData, ThrowOnError>): RequestResult<OidcProtocolEndSessionGetResponses, OidcProtocolEndSessionGetErrors, ThrowOnError> => (options?.client ?? client).get<OidcProtocolEndSessionGetResponses, OidcProtocolEndSessionGetErrors, ThrowOnError>({
    responseType: 'text',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/oauth2/end-session',
    ...options
});

/**
 * End a session using a signed hint or confirmed current session
 */
export const oidcProtocolEndSessionPost = <ThrowOnError extends boolean = false>(options: Options<OidcProtocolEndSessionPostData, ThrowOnError>): RequestResult<OidcProtocolEndSessionPostResponses, OidcProtocolEndSessionPostErrors, ThrowOnError> => (options.client ?? client).post<OidcProtocolEndSessionPostResponses, OidcProtocolEndSessionPostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'text',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/oauth2/end-session',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Render an authorization consent decision
 */
export const oidcProtocolConsentGet = <ThrowOnError extends boolean = false>(options?: Options<OidcProtocolConsentGetData, ThrowOnError>): RequestResult<OidcProtocolConsentGetResponses, OidcProtocolConsentGetErrors, ThrowOnError> => (options?.client ?? client).get<OidcProtocolConsentGetResponses, OidcProtocolConsentGetErrors, ThrowOnError>({
    responseType: 'text',
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/consent',
    ...options
});

/**
 * Submit an authorization consent decision
 */
export const oidcProtocolConsentPost = <ThrowOnError extends boolean = false>(options: Options<OidcProtocolConsentPostData, ThrowOnError>): RequestResult<unknown, OidcProtocolConsentPostErrors, ThrowOnError> => (options.client ?? client).post<unknown, OidcProtocolConsentPostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    security: [{
            key: 'bearerAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/consent',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});
